// import React, { useState } from 'react';
// import {
//   Container,
//   Paper,
//   Typography,
//   TextField,
//   Button,
//   Grid,
//   Snackbar,
//   Alert,
//   Box,
//   CircularProgress,
//   useMediaQuery,
//   useTheme,
// } from '@mui/material';
// import { useNavigate } from 'react-router-dom';

// const RegistrationPage = () => {
//   const navigate = useNavigate();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));

//   const [formData, setFormData] = useState({
//     full_name: '',
//     email: '',
//     password: '',
//     phone_number: '',
//     institution: '',
//     role: 'Student',
//   });
//   const [otp, setOtp] = useState('');
//   const [showOtpField, setShowOtpField] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     if (!showOtpField) {
//       try {
//         const response = await fetch('http://65.0.71.177:8000/api/register_stud/', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify(formData),
//         });
//         const data = await response.json();
//         if (response.ok) {
//           setSnackbar({ open: true, message: data.msg, severity: 'success' });
//           setShowOtpField(true);
//         } else {
//           setSnackbar({ open: true, message: 'Registration failed. Please try again.', severity: 'error' });
//         }
//       } catch (error) {
//         setSnackbar({ open: true, message: 'An error occurred. Please try again.', severity: 'error' });
//       }
//     } else {
//       await verifyOtp();
//     }
//     setLoading(false);
//   };

//   const verifyOtp = async () => {
//     try {
//       const response = await fetch('http://65.0.71.177:8000/api/verify-otp/', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ email: formData.email, otp, role: "Student" }),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         setSnackbar({ open: true, message: 'Registration successful!', severity: 'success' });
//         setTimeout(() => navigate('/'), 2000);
//       } else {
//         setSnackbar({ open: true, message: 'OTP verification failed. Please try again.', severity: 'error' });
//       }
//     } catch (error) {
//       setSnackbar({ open: true, message: 'An error occurred during OTP verification. Please try again.', severity: 'error' });
//     }
//   };

//   return (
//     <Container maxWidth="lg" sx={{ py: 4, minHeight: '100vh', display: 'flex', alignItems: 'center' }}>
//       <Grid container spacing={2} alignItems="stretch">
//         {!isMobile && (
//           <Grid item xs={12} md={6}>
//             <Box
//               sx={{
//                 height: '100%',
//                 background: 'linear-gradient(135deg, #FFD700, #FF4500)',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 flexDirection: 'column',
//                 padding: 4,
//                 color: '#fff',
//                 borderRadius: 2,
//               }}
//             >
//               <Typography variant="h3" fontWeight="bold" gutterBottom>
//                 Practice
//               </Typography>
//               <Typography variant="h5" gutterBottom>
//                 Easy to complex problems
//               </Typography>
//             </Box>
//           </Grid>
//         )}

//         <Grid item xs={12} md={6}>
//           <Paper elevation={3} sx={{ p: 4, borderRadius: 2, height: '100%' }}>
//             <Typography component="h1" variant="h5" align="center" gutterBottom>
//               Ready to Be Unstoppable! Create an account
//             </Typography>

//             <form onSubmit={handleSubmit}>
//               {!showOtpField ? (
//                 <Grid container spacing={2}>
//                   <Grid item xs={12}>
//                     <TextField
//                       name="full_name"
//                       required
//                       fullWidth
//                       label="Full Name"
//                       value={formData.full_name}
//                       onChange={handleChange}
//                     />
//                   </Grid>
//                   <Grid item xs={12}>
//                     <TextField
//                       name="email"
//                       required
//                       fullWidth
//                       label="Email Address"
//                       type="email"
//                       value={formData.email}
//                       onChange={handleChange}
//                     />
//                   </Grid>
//                   <Grid item xs={12}>
//                     <TextField
//                       name="phone_number"
//                       required
//                       fullWidth
//                       label="Phone Number"
//                       value={formData.phone_number}
//                       onChange={handleChange}
//                     />
//                   </Grid>
//                   <Grid item xs={12} >
//                     <TextField
//                       name="password"
//                       required
//                       fullWidth
//                       label="Password"
//                       type="password"
//                       value={formData.password}
//                       onChange={handleChange}
//                     />
//                   </Grid>

//                   <Grid item xs={12}>
//                     <TextField
//                       name="institution"
//                       required
//                       fullWidth
//                       label="Institution"
//                       value={formData.institution}
//                       onChange={handleChange}
//                     />
//                   </Grid>

//                 </Grid>
//               ) : (
//                 <Box sx={{ mt: 2 }}>
//                   <Typography variant="body1" gutterBottom>
//                     Please enter the OTP sent to your email to complete registration.
//                   </Typography>
//                   <TextField
//                     name="otp"
//                     required
//                     fullWidth
//                     label="OTP"
//                     value={otp}
//                     onChange={(e) => setOtp(e.target.value)}
//                     sx={{ mt: 2 }}
//                   />
//                 </Box>
//               )}
//               <Button
//                 type="submit"
//                 fullWidth
//                 variant="contained"
//                 color="primary"
//                 sx={{ mt: 3, mb: 2 }}
//                 disabled={loading}
//               >
//                 {loading ? <CircularProgress size={24} /> : showOtpField ? 'Verify OTP' : 'Next'}
//               </Button>
//             </form>
//             <Typography align="center">
//               Already have an account? <Button onClick={() => navigate('/login')}>Login</Button>
//             </Typography>
//           </Paper>
//         </Grid>
//       </Grid>
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//       >
//         <Alert
//           onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//           severity={snackbar.severity}
//           sx={{ width: '100%' }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Container>
//   );
// };

// export default RegistrationPage;



// import React, { useState } from 'react';
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   IconButton,
//   InputAdornment,
//   Paper,
//   useTheme,
//   useMediaQuery,
//   Snackbar,
//   Alert,
//   CircularProgress,
//   Grid,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
// } from '@mui/material';
// import { Visibility, VisibilityOff, Mail, Lock, Person, Phone, School, Domain } from '@mui/icons-material';
// import { styled } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import LogoImage from '../../src/landpageimage/logo1.png'; // Replace with your logo path
// import FloatingIllustration from '../landpageimage/logo2.jpg';
// // Define theme colors based on the logo
// const themeColors = {
//   primary: '#00A76F', // Green
//   secondary: '#2196F3', // Blue
//   accent: '#FF7043', // Orange
//   gradient: 'linear-gradient(135deg, #00A76F 0%, #2196F3 100%)',
// };

// const Logo = styled('img')({
//   height: '40px',
//   marginBottom: '24px',
// });

// const StyledPaper = styled(Paper)(({ theme }) => ({
//   position: 'relative',
//   width: '100%',
//   maxWidth: '1200px',
//   margin: '20px',
//   borderRadius: '24px',
//   overflow: 'hidden',
//   display: 'flex',
//   boxShadow: '0 20px 40px rgba(0, 167, 111, 0.15)',
//   [theme.breakpoints.down('md')]: {
//     margin: '16px',
//   },
// }));

// const FormSection = styled(Box)(({ theme }) => ({
//   flex: '1',
//   padding: '48px',
//   display: 'flex',
//   flexDirection: 'column',
//   backgroundColor: '#fff',
//   zIndex: 1,
//   [theme.breakpoints.down('sm')]: {
//     padding: '32px 24px',
//   },
// }));

// const WelcomeSection = styled(Box)(({ theme }) => ({
//   flex: '1',
//   padding: '48px',
//   display: 'flex',
//   flexDirection: 'column',
//   justifyContent: 'center',
//   alignItems: 'center',
//   background: themeColors.gradient,
//   position: 'relative',
//   overflow: 'hidden',
//   [theme.breakpoints.down('md')]: {
//     display: 'none',
//   },
// }));

// const StyledTextField = styled(TextField)(({ theme }) => ({
//   '& .MuiOutlinedInput-root': {
//     borderRadius: '16px',
//     backgroundColor: '#F3F4F6',
//     transition: 'all 0.2s ease-in-out',
//     '&:hover': {
//       backgroundColor: '#F9FAFB',
//     },
//     '&.Mui-focused': {
//       backgroundColor: '#F9FAFB',
//       '& fieldset': {
//         borderColor: themeColors.primary,
//         borderWidth: '2px',
//       },
//     },
//   },
//   '& .MuiInputLabel-root.Mui-focused': {
//     color: themeColors.primary,
//   },
// }));

// const StyledSelect = styled(Select)(({ theme }) => ({
//   '& .MuiOutlinedInput-root': {
//     borderRadius: '16px',
//     backgroundColor: '#F3F4F6',
//     transition: 'all 0.2s ease-in-out',
//     '&:hover': {
//       backgroundColor: '#F9FAFB',
//     },
//     '&.Mui-focused': {
//       backgroundColor: '#F9FAFB',
//       '& fieldset': {
//         borderColor: themeColors.primary,
//         borderWidth: '2px',
//       },
//     },
//   },
// }));

// const RegisterButton = styled(Button)(({ theme }) => ({
//   backgroundColor: themeColors.primary,
//   color: 'white',
//   padding: '14px',
//   borderRadius: '16px',
//   textTransform: 'none',
//   fontSize: '16px',
//   fontWeight: 600,
//   transition: 'all 0.2s ease-in-out',
//   '&:hover': {
//     backgroundColor: '#008F5D',
//     transform: 'translateY(-2px)',
//     boxShadow: '0 8px 16px rgba(0, 167, 111, 0.2)',
//   },
// }));

// const FloatingImage = styled('img')({
//   position: 'absolute',
//   width: '100%',
//   maxWidth: '400px',
//   height: 'auto',
//   zIndex: 1,
// });

// export default function StudentRegister() {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));
//   const navigate = useNavigate();
//   const [showPassword, setShowPassword] = useState(false);
//   const [formData, setFormData] = useState({
//     full_name: '',
//     email: '',
//     password: '',
//     phone_number: '',
//     institution: '',
//     domain: '',
//     role: 'Student',
//   });
//   const [otp, setOtp] = useState('');
//   const [showOtpField, setShowOtpField] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     if (!showOtpField) {
//       try {
//         const response = await fetch('http://65.0.71.177:8000/api/register_stud/', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify(formData),
//         });
//         const data = await response.json();
//         if (response.ok) {
//           setSnackbar({ open: true, message: data.msg, severity: 'success' });
//           setShowOtpField(true);
//         } else {
//           setSnackbar({ open: true, message: 'Registration failed. Please try again.', severity: 'error' });
//         }
//       } catch (error) {
//         setSnackbar({ open: true, message: 'An error occurred. Please try again.', severity: 'error' });
//       }
//     } else {
//       await verifyOtp();
//     }
//     setLoading(false);
//   };

//   const verifyOtp = async () => {
//     try {
//       const response = await fetch('http://65.0.71.177:8000/api/verify-otp/', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ email: formData.email, otp, role: "Student" }),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         setSnackbar({ open: true, message: 'Registration successful!', severity: 'success' });
//         setTimeout(() => navigate('/Login'), 2000);
//       } else {
//         setSnackbar({ open: true, message: 'OTP verification failed. Please try again.', severity: 'error' });
//       }
//     } catch (error) {
//       setSnackbar({ open: true, message: 'An error occurred during OTP verification. Please try again.', severity: 'error' });
//     }
//   };

//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         backgroundColor: '#F3F4F6',
//         padding: { xs: '16px', sm: '24px' },
//         background: 'linear-gradient(135deg, #E6F7F1 0%, #E3F2FD 100%)',
//       }}
//     >
//       <StyledPaper>
//         <FormSection>
//           <Box>
//             <Logo src={LogoImage} alt="Company Logo" />
//             <Typography 
//               variant="h3" 
//               fontWeight="800" 
//               sx={{ 
//                 mb: 1,
//                 background: themeColors.gradient,
//                 WebkitBackgroundClip: 'text',
//                 WebkitTextFillColor: 'transparent',
//               }}
//             >
//               Join Us! As Student
//             </Typography>
//             <Typography variant="h6" color="text.secondary" fontWeight="500">
//               Create your student account and start your journey
//             </Typography>
//           </Box>

//           <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
//             {!showOtpField ? (
//               <Grid container spacing={2}>
//                 <Grid item xs={12}>
//                   <StyledTextField
//                     fullWidth
//                     label="Full Name"
//                     name="full_name"
//                     value={formData.full_name}
//                     onChange={handleChange}
//                     required
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <Person sx={{ color: themeColors.primary }} />
//                         </InputAdornment>
//                       ),
//                     }}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <StyledTextField
//                     fullWidth
//                     label="Email"
//                     name="email"
//                     type="email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     required
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <Mail sx={{ color: themeColors.primary }} />
//                         </InputAdornment>
//                       ),
//                     }}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <StyledTextField
//                     fullWidth
//                     label="Password"
//                     name="password"
//                     type={showPassword ? 'text' : 'password'}
//                     value={formData.password}
//                     onChange={handleChange}
//                     required
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <Lock sx={{ color: themeColors.primary }} />
//                         </InputAdornment>
//                       ),
//                       endAdornment: (
//                         <InputAdornment position="end">
//                           <IconButton
//                             onClick={() => setShowPassword(!showPassword)}
//                             edge="end"
//                           >
//                             {showPassword ? <VisibilityOff /> : <Visibility />}
//                           </IconButton>
//                         </InputAdornment>
//                       ),
//                     }}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <StyledTextField
//                     fullWidth
//                     label="Phone Number"
//                     name="phone_number"
//                     value={formData.phone_number}
//                     onChange={handleChange}
//                     required
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <Phone sx={{ color: themeColors.primary }} />
//                         </InputAdornment>
//                       ),
//                     }}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <StyledTextField
//                     fullWidth
//                     label="Institution"
//                     name="institution"
//                     value={formData.institution}
//                     onChange={handleChange}
//                     required
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <School sx={{ color: themeColors.primary }} />
//                         </InputAdornment>
//                       ),
//                     }}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <FormControl fullWidth>
//                     <InputLabel id="domain-label">Domain</InputLabel>
//                     <StyledSelect
//                       labelId="domain-label"
//                       name="domain"
//                       value={formData.domain}
//                       label="Domain"
//                       onChange={handleChange}
//                       required
//                       startAdornment={
//                         <InputAdornment position="start">
//                           <Domain sx={{ color: themeColors.primary }} />
//                         </InputAdornment>
//                       }
//                     >
//                       <MenuItem value="AI/ML">AI/ML</MenuItem>
//                       <MenuItem value="Technology">Technology</MenuItem>
//                       <MenuItem value="Real Estate">Real Estate</MenuItem>
//                       <MenuItem value="Healthcare and Biotech">Healthcare and Biotech</MenuItem>
//                       <MenuItem value="E-commerce and Retail">E-commerce and Retail</MenuItem>
//                       <MenuItem value="Education">Education</MenuItem>
//                       <MenuItem value="Finance and FinTech">Finance and FinTech</MenuItem>
//                       <MenuItem value="Energy and Sustainability">Energy and Sustainability</MenuItem>
//                       <MenuItem value="Entertainment and Media">Entertainment and Media</MenuItem>
//                       <MenuItem value="Agriculture and Food">Agriculture and Food</MenuItem>
//                       <MenuItem value="Fashion and Lifestyle">Fashion and Lifestyle</MenuItem>
//                       <MenuItem value="Others">Others</MenuItem>
//                     </StyledSelect>
//                   </FormControl>
//                 </Grid>
//               </Grid>
//             ) : (
//               <StyledTextField
//                 fullWidth
//                 label="OTP"
//                 name="otp"
//                 value={otp}
//                 onChange={(e) => setOtp(e.target.value)}
//                 required
//               />
//             )}
//             <RegisterButton type="submit" fullWidth disabled={loading}>
//               {loading ? <CircularProgress size={24} /> : showOtpField ? 'Verify OTP' : 'Register'}
//             </RegisterButton>
//           </form>

//           <Typography 
//             variant="body2" 
//             color="text.secondary" 
//             align="center"
//             sx={{ mt: 2 }}
//           >
//             Already have an account?{' '}
//             <Button
//               onClick={() => navigate('/Login')}
//               sx={{
//                 color: themeColors.primary,
//                 textTransform: 'none',
//                 fontWeight: 500,
//                 '&:hover': { 
//                   backgroundColor: 'transparent',
//                   textDecoration: 'underline',
//                 },
//               }}
//             >
//               Login
//             </Button>
//           </Typography>
//         </FormSection>

//         <WelcomeSection>
//           <Box
//             sx={{
//               position: 'relative',
//               width: '100%',
//               height: '100%',
//               display: 'flex',
//               flexDirection: 'column',
//               alignItems: 'center',
//               justifyContent: 'center',
//               color: 'white',
//               textAlign: 'center',
//               zIndex: 2,
//             }}
//           >
//             <FloatingImage
//               src={FloatingIllustration}
//               alt="Registration illustration"
//               sx={{
//                 animation: 'float 6s ease-in-out infinite',
//                 '@keyframes float': {
//                   '0%, 100%': {
//                     transform: 'translateY(0)',
//                   },
//                   '50%': {
//                     transform: 'translateY(-20px)',
//                   },
//                 },
//               }}
//             />
//             <Typography 
//               variant="h4" 
//               fontWeight="bold" 
//               sx={{ mt: 4, mb: 2 }}
//             >
//               Welcome Students!
//             </Typography>
//             <Typography 
//               variant="body1" 
//               sx={{ 
//                 opacity: 0.9,
//                 maxWidth: '400px',
//               }}
//             >
//               Join our community of learners and innovators. Your educational journey starts here!
//             </Typography>
//           </Box>
          
//           {/* Decorative elements */}
//           <Box
//             sx={{
//               position: 'absolute',
//               top: 0,
//               left: 0,
//               right: 0,
//               bottom: 0,
//               opacity: 0.1,
//               background: 'radial-gradient(circle at 30% 107%, #00A76F 0%, transparent 45%)',
//             }}
//           />
//           <Box
//             sx={{
//               position: 'absolute',
//               top: '50%',
//               left: '50%',
//               width: '200%',
//               height: '200%',
//               transform: 'translate(-50%, -50%) rotate(-10deg)',
//               background: 'linear-gradient(45deg, transparent 45%, rgba(255,255,255,0.1) 45%, rgba(255,255,255,0.1) 55%, transparent 55%)',
//             }}
//           />
//         </WelcomeSection>
//       </StyledPaper>
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <Alert
//           onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//           severity={snackbar.severity}
//           sx={{ width: '100%' }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// }


// import React, { useState } from 'react';
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   IconButton,
//   InputAdornment,
//   Paper,
//   Snackbar,
//   Alert,
//   CircularProgress,
//   Grid,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Checkbox,
//   FormControlLabel,
// } from '@mui/material';
// import { Visibility, VisibilityOff, Mail, Lock, Person, Phone, Home, CalendarToday, School, Domain } from '@mui/icons-material';
// import { styled } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';

// const themeColors = {
//   primary: '#00A76F',
//   secondary: '#2196F3',
//   accent: '#FF7043',
//   gradient: 'linear-gradient(135deg, #00A76F 0%, #2196F3 100%)',
// };

// const StyledPaper = styled(Paper)(({ theme }) => ({
//   position: 'relative',
//   width: '100%',
//   maxWidth: '1200px',
//   margin: '20px',
//   borderRadius: '24px',
//   overflow: 'hidden',
//   display: 'flex',
//   boxShadow: '0 20px 40px rgba(0, 167, 111, 0.15)',
// }));

// const FormSection = styled(Box)(({ theme }) => ({
//   flex: '1',
//   padding: '48px',
//   display: 'flex',
//   flexDirection: 'column',
//   backgroundColor: '#fff',
//   zIndex: 1,
// }));

// const StyledTextField = styled(TextField)(({ theme }) => ({
//   '& .MuiOutlinedInput-root': {
//     borderRadius: '16px',
//     backgroundColor: '#F3F4F6',
//     transition: 'all 0.2s ease-in-out',
//     '&:hover': {
//       backgroundColor: '#F9FAFB',
//     },
//     '&.Mui-focused': {
//       backgroundColor: '#F9FAFB',
//       '& fieldset': {
//         borderColor: themeColors.primary,
//         borderWidth: '2px',
//       },
//     },
//   },
//   '& .MuiInputLabel-root.Mui-focused': {
//     color: themeColors.primary,
//   },
// }));

// const RegisterButton = styled(Button)(({ theme }) => ({
//   backgroundColor: themeColors.primary,
//   color: 'white',
//   padding: '14px',
//   borderRadius: '16px',
//   textTransform: 'none',
//   fontSize: '16px',
//   fontWeight: 600,
//   transition: 'all 0.2s ease-in-out',
//   '&:hover': {
//     backgroundColor: '#008F5D',
//     transform: 'translateY(-2px)',
//     boxShadow: '0 8px 16px rgba(0, 167, 111, 0.2)',
//   },
// }));

// export default function StudentRegister() {
//   const navigate = useNavigate();
//   const [showPassword, setShowPassword] = useState(false);
//   const [formData, setFormData] = useState({
//     full_name: '',
//     email: '',
//     password: '',
//     confirm_password: '',
//     phone_number: '',
//     address: '',
//     city: '',
//     state: '',
//     postal_code: '',
//     country: '',
//     date_of_birth: '',
//     gender: '',
//     institution: '',
//     field_of_study: '',
//     graduation_year: '',
//     role: 'Student',
//     communication_preference: 'Email',
//     consent: false,
//   });
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: type === 'checkbox' ? checked : value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       const response = await fetch('http://65.0.71.177:8000/api/register_stud/', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(formData),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         setSnackbar({ open: true, message: 'Registration successful!', severity: 'success' });
//         setTimeout(() => navigate('/Login'), 2000);
//       } else {
//         setSnackbar({ open: true, message: data.msg || 'Registration failed!', severity: 'error' });
//       }
//     } catch (error) {
//       setSnackbar({ open: true, message: 'An error occurred. Please try again.', severity: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         backgroundColor: '#F3F4F6',
//       }}
//     >
//       <StyledPaper>
//         <FormSection>
//           <Typography variant="h4" fontWeight="bold" mb={2}>
//             Student Registration
//           </Typography>
//           <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
//             <Grid container spacing={2}>
//               <Grid item xs={12} md={6}>
//                 <StyledTextField
//                   fullWidth
//                   label="Full Name"
//                   name="full_name"
//                   value={formData.full_name}
//                   onChange={handleChange}
//                   required
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <StyledTextField
//                   fullWidth
//                   label="Email"
//                   name="email"
//                   type="email"
//                   value={formData.email}
//                   onChange={handleChange}
//                   required
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <StyledTextField
//                   fullWidth
//                   label="Password"
//                   name="password"
//                   type={showPassword ? 'text' : 'password'}
//                   value={formData.password}
//                   onChange={handleChange}
//                   required
//                   InputProps={{
//                     endAdornment: (
//                       <InputAdornment position="end">
//                         <IconButton onClick={() => setShowPassword(!showPassword)}>
//                           {showPassword ? <VisibilityOff /> : <Visibility />}
//                         </IconButton>
//                       </InputAdornment>
//                     ),
//                   }}
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <StyledTextField
//                   fullWidth
//                   label="Confirm Password"
//                   name="confirm_password"
//                   type={showPassword ? 'text' : 'password'}
//                   value={formData.confirm_password}
//                   onChange={handleChange}
//                   required
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <StyledTextField
//                   fullWidth
//                   label="Phone Number"
//                   name="phone_number"
//                   value={formData.phone_number}
//                   onChange={handleChange}
//                   required
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <StyledTextField
//                   fullWidth
//                   label="Date of Birth"
//                   name="date_of_birth"
//                   type="date"
//                   InputLabelProps={{ shrink: true }}
//                   value={formData.date_of_birth}
//                   onChange={handleChange}
//                   required
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <FormControl fullWidth>
//                   <InputLabel id="gender-label">Gender</InputLabel>
//                   <Select
//                     labelId="gender-label"
//                     name="gender"
//                     value={formData.gender}
//                     onChange={handleChange}
//                     required
//                   >
//                     <MenuItem value="Male">Male</MenuItem>
//                     <MenuItem value="Female">Female</MenuItem>
//                     <MenuItem value="Other">Other</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <StyledTextField
//                   fullWidth
//                   label="Address"
//                   name="address"
//                   value={formData.address}
//                   onChange={handleChange}
//                   required
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <StyledTextField
//                   fullWidth
//                   label="City"
//                   name="city"
//                   value={formData.city}
//                   onChange={handleChange}
//                   required
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <StyledTextField
//                   fullWidth
//                   label="State"
//                   name="state"
//                   value={formData.state}
//                   onChange={handleChange}
//                   required
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <StyledTextField
//                   fullWidth
//                   label="Postal Code"
//                   name="postal_code"
//                   value={formData.postal_code}
//                   onChange={handleChange}
//                   required
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <StyledTextField
//                   fullWidth
//                   label="Country"
//                   name="country"
//                   value={formData.country}
//                   onChange={handleChange}
//                   required
//                 />
//               </Grid>
//               <Grid item xs={12}>
//                 <StyledTextField
//                   fullWidth
//                   label="Institution Name"
//                   name="institution"
//                   value={formData.institution}
//                   onChange={handleChange}
//                   required
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <StyledTextField
//                   fullWidth
//                   label="Field of Study"
//                   name="field_of_study"
//                   value={formData.field_of_study}
//                   onChange={handleChange}
//                   required
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <StyledTextField
//                   fullWidth
//                   label="Graduation Year"
//                   name="graduation_year"
//                   type="number"
//                   value={formData.graduation_year}
//                   onChange={handleChange}
//                   required
//                 />
//               </Grid>
//               <Grid item xs={12}>
//                 <FormControl fullWidth>
//                   <InputLabel id="communication-label">Preferred Communication</InputLabel>
//                   <Select
//                     labelId="communication-label"
//                     name="communication_preference"
//                     value={formData.communication_preference}
//                     onChange={handleChange}
//                   >
//                     <MenuItem value="Email">Email</MenuItem>
//                     <MenuItem value="Phone">Phone</MenuItem>
//                     <MenuItem value="SMS">SMS</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>
//               <Grid item xs={12}>
//                 <FormControlLabel
//                   control={<Checkbox name="consent" checked={formData.consent} onChange={handleChange} />}
//                   label="I agree to the terms and conditions"
//                 />
//               </Grid>
//             </Grid>
//             <RegisterButton type="submit" fullWidth disabled={loading}>
//               {loading ? <CircularProgress size={24} /> : 'Register'}
//             </RegisterButton>
//           </form>
//         </FormSection>
//       </StyledPaper>
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <Alert
//           onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//           severity={snackbar.severity}
//           sx={{ width: '100%' }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// // }
// import React, { useState } from 'react';
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   IconButton,
//   InputAdornment,
//   Paper,
//   Snackbar,
//   Alert,
//   CircularProgress,
//   Grid,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Checkbox,
//   FormControlLabel,
// } from '@mui/material';
// import { Visibility, VisibilityOff } from '@mui/icons-material';
// import { styled } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import Logo from "../landpageimage/logo2.jpg"

// const themeColors = {
//   primary: '#00A76F',
//   gradient: 'linear-gradient(135deg, #00A76F 0%, #2196F3 100%)',
// };

// const StyledPaper = styled(Paper)(() => ({
//   display: 'flex',
//   width: '100%',
//   maxWidth: '1200px',
//   borderRadius: '24px',
//   overflow: 'hidden',
//   boxShadow: '0 20px 40px rgba(0, 167, 111, 0.15)',
// }));

// const FormSection = styled(Box)(() => ({
//   flex: 1,
//   padding: '48px',
//   display: 'flex',
//   flexDirection: 'column',
//   justifyContent: 'center',
//   backgroundColor: '#fff',
// }));

// const LogoSection = styled(Box)(() => ({
//   flex: 1,
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'center',
//   background: themeColors.gradient,
// }));

// const StyledTextField = styled(TextField)(() => ({
//   '& .MuiOutlinedInput-root': {
//     borderRadius: '16px',
//     backgroundColor: '#F3F4F6',
//     '&:hover': {
//       backgroundColor: '#F9FAFB',
//     },
//     '&.Mui-focused fieldset': {
//       borderColor: themeColors.primary,
//     },
//   },
// }));

// const RegisterButton = styled(Button)(() => ({
//   backgroundColor: themeColors.primary,
//   color: 'white',
//   padding: '12px',
//   borderRadius: '16px',
//   fontWeight: 600,
//   '&:hover': {
//     backgroundColor: '#008F5D',
//   },
// }));

// export default function StudentRegister() {
//   const navigate = useNavigate();
//   const [showPassword, setShowPassword] = useState(false);
//   const [formData, setFormData] = useState({
//     full_name: '',
//     email: '',
//     password: '',
//     confirm_password: '',
//     phone_number: '',
//     address: '',
//     city: '',
//     state: '',
//     postal_code: '',
//     country: '',
//     date_of_birth: '',
//     gender: '',
//     institution: '',
//     field_of_study: '',
//     graduation_year: '',
//     role: 'Student',
//     communication_preference: 'Email',
//     consent: false,
//   });
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: type === 'checkbox' ? checked : value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       const response = await fetch('http://65.0.71.177:8000/api/register_stud/', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(formData),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         setSnackbar({ open: true, message: 'Registration successful!', severity: 'success' });
//         setTimeout(() => navigate('/Login'), 2000);
//       } else {
//         setSnackbar({ open: true, message: data.msg || 'Registration failed!', severity: 'error' });
//       }
//     } catch (error) {
//       setSnackbar({ open: true, message: 'An error occurred. Please try again.', severity: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         backgroundColor: '#F3F4F6',
//       }}
//     >
//       <StyledPaper>
//         <FormSection>
//           <Typography variant="h4" fontWeight="bold" mb={2}>
//             Join Us! As Student
//           </Typography>
//           <Typography variant="body1" mb={3}>
//             Create your student account and start your journey
//           </Typography>
//           <form onSubmit={handleSubmit}>
//             <Grid container spacing={2}>
//               {[
//                 { name: 'full_name', label: 'Full Name' },
//                 { name: 'email', label: 'Email', type: 'email' },
//                 {
//                   name: 'password',
//                   label: 'Password',
//                   type: showPassword ? 'text' : 'password',
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton onClick={() => setShowPassword(!showPassword)}>
//                         {showPassword ? <VisibilityOff /> : <Visibility />}
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 },
//                 { name: 'confirm_password', label: 'Confirm Password', type: showPassword ? 'text' : 'password' },
//                 { name: 'phone_number', label: 'Phone Number' },
//                 { name: 'address', label: 'Address' },
//                 { name: 'city', label: 'City' },
//                 { name: 'state', label: 'State' },
//                 { name: 'postal_code', label: 'Postal Code' },
//                 { name: 'country', label: 'Country' },
//                 { name: 'institution', label: 'Institution Name' },
//                 { name: 'field_of_study', label: 'Field of Study' },
//               ].map((field) => (
//                 <Grid item xs={12} md={6} key={field.name}>
//                   <StyledTextField
//                     fullWidth
//                     label={field.label}
//                     name={field.name}
//                     type={field.type || 'text'}
//                     value={formData[field.name]}
//                     onChange={handleChange}
//                     required
//                     InputProps={{ endAdornment: field.endAdornment || null }}
//                   />
//                 </Grid>
//               ))}
//               <Grid item xs={12} md={6}>
//                 <StyledTextField
//                   fullWidth
//                   label="Date of Birth"
//                   name="date_of_birth"
//                   type="date"
//                   InputLabelProps={{ shrink: true }}
//                   value={formData.date_of_birth}
//                   onChange={handleChange}
//                   required
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <FormControl fullWidth>
//                   <InputLabel id="gender-label">Gender</InputLabel>
//                   <Select
//                     labelId="gender-label"
//                     name="gender"
//                     value={formData.gender}
//                     onChange={handleChange}
//                     required
//                   >
//                     <MenuItem value="Male">Male</MenuItem>
//                     <MenuItem value="Female">Female</MenuItem>
//                     <MenuItem value="Other">Other</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <StyledTextField
//                   fullWidth
//                   label="Graduation Year"
//                   name="graduation_year"
//                   type="number"
//                   value={formData.graduation_year}
//                   onChange={handleChange}
//                   required
//                 />
//               </Grid>
//               <Grid item xs={12}>
//                 <FormControl fullWidth>
//                   <InputLabel id="communication-label">Preferred Communication</InputLabel>
//                   <Select
//                     labelId="communication-label"
//                     name="communication_preference"
//                     value={formData.communication_preference}
//                     onChange={handleChange}
//                   >
//                     <MenuItem value="Email">Email</MenuItem>
//                     <MenuItem value="Phone">Phone</MenuItem>
//                     <MenuItem value="SMS">SMS</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>
//               <Grid item xs={12}>
//                 <FormControlLabel
//                   control={<Checkbox name="consent" checked={formData.consent} onChange={handleChange} />}
//                   label="I agree to the terms and conditions"
//                 />
//               </Grid>
//               <Grid item xs={12}>
//                 <RegisterButton type="submit" fullWidth disabled={loading}>
//                   {loading ? <CircularProgress size={24} /> : 'Register'}
//                 </RegisterButton>
//               </Grid>
//             </Grid>
//           </form>
//         </FormSection>
//         <LogoSection>
//           <Box
//             component="img"
//             src={Logo}
//             alt="Logo"
//             sx={{ width: '80%', maxWidth: '300px' }}
//           />
//         </LogoSection>
//       </StyledPaper>
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <Alert
//           onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//           severity={snackbar.severity}
//           sx={{ width: '100%' }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// }

// import React, { useState } from 'react';
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   IconButton,
//   InputAdornment,
//   Paper,
//   Snackbar,
//   Alert,
//   CircularProgress,
//   Grid,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Checkbox,
//   FormControlLabel,
// } from '@mui/material';
// import { Visibility, VisibilityOff } from '@mui/icons-material';
// import { styled } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// // import Logo1 from '../landpageimage/logo1.png';
// import Logo1 from '../../src/landpageimage/logo1.png'
// import Logo2 from '../../src/landpageimage/logo1.png';
// import Logo3 from '../../src/landpageimage/logo1.png';
// import Logo4 from '../../src/landpageimage/logo1.png';

// const themeColors = {
//   primary: '#00A76F',
//   gradient: 'linear-gradient(135deg, #00A76F 0%, #2196F3 100%)',
//   background: '#F3F4F6',
//   vibrantBackground: 'linear-gradient(135deg, #00A76F 0%, #2196F3 70%, #FFC107 100%)',
// };

// const StyledPaper = styled(Paper)(() => ({
//   display: 'flex',
//   flexDirection: 'column',
//   alignItems: 'center',
//   width: '90%',
//   maxWidth: '1400px',
//   margin: '0 auto',
//   borderRadius: '24px',
//   overflow: 'hidden',
//   padding: '24px',
//   backgroundColor: '#FFFFFF',
//   boxShadow: '0 20px 40px rgba(0, 167, 111, 0.15)',
// }));

// const LogoContainer = styled(Box)(() => ({
//   display: 'flex',
//   justifyContent: 'space-around',
//   alignItems: 'center',
//   width: '100%',
//   background: themeColors.vibrantBackground,
//   padding: '16px 0',
//   borderRadius: '12px',
// }));

// const LogoImage = styled('img')(() => ({
//   width: '100px',
//   height: 'auto',
// }));

// const RegisterSection = styled(Box)(() => ({
//   width: '100%',
//   display: 'flex',
//   flexDirection: 'column',
//   alignItems: 'center',
// }));

// const StyledTextField = styled(TextField)(() => ({
//   '& .MuiOutlinedInput-root': {
//     borderRadius: '16px',
//     backgroundColor: '#F3F4F6',
//     '&:hover': {
//       backgroundColor: '#F9FAFB',
//     },
//     '&.Mui-focused fieldset': {
//       borderColor: themeColors.primary,
//     },
//   },
// }));

// const RegisterButton = styled(Button)(() => ({
//   backgroundColor: themeColors.primary,
//   color: 'white',
//   padding: '12px',
//   borderRadius: '16px',
//   fontWeight: 600,
//   '&:hover': {
//     backgroundColor: '#008F5D',
//   },
// }));

// export default function StudentRegister() {
//   const navigate = useNavigate();
//   const [showPassword, setShowPassword] = useState(false);
//   const [formData, setFormData] = useState({
//     full_name: '',
//     email: '',
//     password: '',
//     confirm_password: '',
//     phone_number: '',
//     address: '',
//     city: '',
//     state: '',
//     postal_code: '',
//     country: '',
//     date_of_birth: '',
//     gender: '',
//     institution: '',
//     field_of_study: '',
//     graduation_year: '',
//     communication_preference: 'Email',
//     consent: false,
//   });
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: type === 'checkbox' ? checked : value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       const response = await fetch('http://65.0.71.177:8000/api/register_stud/', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(formData),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         setSnackbar({ open: true, message: 'Registration successful!', severity: 'success' });
//         setTimeout(() => navigate('/Login'), 2000);
//       } else {
//         setSnackbar({ open: true, message: data.msg || 'Registration failed!', severity: 'error' });
//       }
//     } catch (error) {
//       setSnackbar({ open: true, message: 'An error occurred. Please try again.', severity: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box sx={{
//       minHeight: '100vh',
//       display: 'flex',
//       flexDirection: 'column',
//       alignItems: 'center',
//       justifyContent: 'center',
//       backgroundColor: themeColors.background,
//     }}>
//       <StyledPaper>
//         <LogoContainer>
//           <LogoImage src={Logo1} alt="Logo 1" />
//           <LogoImage src={Logo2} alt="Logo 2" />
//           <LogoImage src={Logo3} alt="Logo 3" />
//           <LogoImage src={Logo4} alt="Logo 4" />
//         </LogoContainer>

//         <RegisterSection>
//           <Typography variant="h4" fontWeight="bold" mb={2} sx={{ color: themeColors.primary }}>
//             Welcome, Future Achiever!
//           </Typography>
//           <Typography variant="body1" mb={3}>
//             Start your journey by registering below.
//           </Typography>

//           <form onSubmit={handleSubmit} style={{ width: '100%' }}>
//             <Grid container spacing={2}>
//               {[{
//                 name: 'full_name', label: 'Full Name'
//               }, {
//                 name: 'email', label: 'Email', type: 'email'
//               }, {
//                 name: 'password', label: 'Password', type: showPassword ? 'text' : 'password',
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton onClick={() => setShowPassword(!showPassword)}>
//                       {showPassword ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 )
//               }].map((field) => (
//                 <Grid item xs={12} md={6} key={field.name}>
//                   <StyledTextField
//                     fullWidth
//                     label={field.label}
//                     name={field.name}
//                     type={field.type || 'text'}
//                     value={formData[field.name]}
//                     onChange={handleChange}
//                     required
//                     InputProps={{ endAdornment: field.endAdornment || null }}
//                   />
//                 </Grid>
//               ))}
//               <Grid item xs={12} md={6}>
//                 <StyledTextField
//                   fullWidth
//                   label="Date of Birth"
//                   name="date_of_birth"
//                   type="date"
//                   InputLabelProps={{ shrink: true }}
//                   value={formData.date_of_birth}
//                   onChange={handleChange}
//                   required
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <FormControl fullWidth>
//                   <InputLabel id="gender-label">Gender</InputLabel>
//                   <Select
//                     labelId="gender-label"
//                     name="gender"
//                     value={formData.gender}
//                     onChange={handleChange}
//                     required
//                   >
//                     <MenuItem value="Male">Male</MenuItem>
//                     <MenuItem value="Female">Female</MenuItem>
//                     <MenuItem value="Other">Other</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <StyledTextField
//                   fullWidth
//                   label="Graduation Year"
//                   name="graduation_year"
//                   type="number"
//                   value={formData.graduation_year}
//                   onChange={handleChange}
//                   required
//                 />
//               </Grid>
//               <Grid item xs={12}>
//                 <FormControl fullWidth>
//                   <InputLabel id="communication-label">Preferred Communication</InputLabel>
//                   <Select
//                     labelId="communication-label"
//                     name="communication_preference"
//                     value={formData.communication_preference}
//                     onChange={handleChange}
//                   >
//                     <MenuItem value="Email">Email</MenuItem>
//                     <MenuItem value="Phone">Phone</MenuItem>
//                     <MenuItem value="SMS">SMS</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>
//               <Grid item xs={12}>
//                 <FormControlLabel
//                   control={<Checkbox name="consent" checked={formData.consent} onChange={handleChange} />}
//                   label="I agree to the terms and conditions"
//                 />
//               </Grid>
//               <Grid item xs={12}>
//                 <RegisterButton type="submit" fullWidth disabled={loading}>
//                   {loading ? <CircularProgress size={24} /> : 'Register'}
//                 </RegisterButton>
//               </Grid>
//             </Grid>
//           </form>
//         </RegisterSection>
//       </StyledPaper>
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <Alert
//           onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//           severity={snackbar.severity}
//           sx={{ width: '100%' }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// }

// import React, { useState } from 'react';
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   IconButton,
//   InputAdornment,
//   Paper,
//   Snackbar,
//   Alert,
//   CircularProgress,
//   Grid,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Checkbox,
//   FormControlLabel,
// } from '@mui/material';
// import { Visibility, VisibilityOff } from '@mui/icons-material';
// import { styled } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import Logo1 from '../../src/landpageimage/logo1.png';
// import Logo2 from '../../src/landpageimage/logo1.png';
// import Logo3 from '../../src/landpageimage/logo1.png';
// import Logo4 from '../../src/landpageimage/logo1.png';

// const themeColors = {
//   primary: '#00A76F',
//   gradient: 'linear-gradient(135deg, #00A76F 0%, #2196F3 100%)',
//   background: '#F3F4F6',
// };

// const StyledPaper = styled(Paper)(() => ({
//   display: 'flex',
//   flexDirection: 'column',
//   alignItems: 'center',
//   width: '90%',
//   maxWidth: '1400px',
//   margin: '0 auto',
//   borderRadius: '24px',
//   overflow: 'hidden',
//   padding: '24px',
//   backgroundColor: '#FFFFFF',
//   boxShadow: '0 20px 40px rgba(0, 167, 111, 0.15)',
// }));

// const LogoContainer = styled(Box)(() => ({
//   display: 'flex',
//   justifyContent: 'space-around',
//   alignItems: 'center',
//   width: '100%',
//   padding: '16px 0',
//   marginBottom: '24px',
// }));

// const LogoImage = styled('img')(() => ({
//   width: '100px',
//   height: 'auto',
// }));

// const StyledTextField = styled(TextField)(() => ({
//   '& .MuiOutlinedInput-root': {
//     borderRadius: '16px',
//     backgroundColor: '#F3F4F6',
//     '&:hover': {
//       backgroundColor: '#F9FAFB',
//     },
//     '&.Mui-focused fieldset': {
//       borderColor: themeColors.primary,
//     },
//   },
// }));

// const RegisterButton = styled(Button)(() => ({
//   backgroundColor: themeColors.primary,
//   color: 'white',
//   padding: '12px',
//   borderRadius: '16px',
//   fontWeight: 600,
//   '&:hover': {
//     backgroundColor: '#008F5D',
//   },
// }));

// export default function StudentRegister() {
//   const navigate = useNavigate();
//   const [showPassword, setShowPassword] = useState(false);
//   const [formData, setFormData] = useState({
//     full_name: '',
//     email: '',
//     password: '',
//     confirm_password: '',
//     phone_number: '',
//     address: '',
//     city: '',
//     state: '',
//     postal_code: '',
//     country: '',
//     date_of_birth: '',
//     gender: '',
//     institution: '',
//     field_of_study: '',
//     graduation_year: '',
//     role: 'Student',
//     communication_preference: 'Email',
//     consent: false,
//   });
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: type === 'checkbox' ? checked : value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       const response = await fetch('http://65.0.71.177:8000/api/register_stud/', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(formData),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         setSnackbar({ open: true, message: 'Registration successful!', severity: 'success' });
//         setTimeout(() => navigate('/Login'), 2000);
//       } else {
//         setSnackbar({ open: true, message: data.msg || 'Registration failed!', severity: 'error' });
//       }
//     } catch (error) {
//       setSnackbar({ open: true, message: 'An error occurred. Please try again.', severity: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//         justifyContent: 'center',
//         backgroundColor: themeColors.background,
//       }}
//     >
//       <StyledPaper>
//         <LogoContainer>
//           <LogoImage src={Logo1} alt="Logo 1" />
//           <LogoImage src={Logo2} alt="Logo 2" />
//           <LogoImage src={Logo3} alt="Logo 3" />
//           <LogoImage src={Logo4} alt="Logo 4" />
//         </LogoContainer>

//         <Typography variant="h4" fontWeight="bold" mb={2} sx={{ color: themeColors.primary }}>
//           Welcome, Future Achiever!
//         </Typography>
//         <Typography variant="body1" mb={3}>
//           Start your journey by registering below.
//         </Typography>

//         <form onSubmit={handleSubmit} style={{ width: '100%' }}>
//           <Grid container spacing={2}>
//             {Object.entries({
//               full_name: 'Full Name',
//               email: 'Email',
//               phone_number: 'Phone Number',
//               address: 'Address',
//               city: 'City',
//               state: 'State',
//               postal_code: 'Postal Code',
//               country: 'Country',
//               institution: 'Institution',
//               field_of_study: 'Field of Study',
//               graduation_year: 'Graduation Year',
//             }).map(([name, label]) => (
//               <Grid item xs={12} md={6} key={name}>
//                 <StyledTextField
//                   fullWidth
//                   label={label}
//                   name={name}
//                   type={name === 'graduation_year' ? 'number' : 'text'}
//                   value={formData[name]}
//                   onChange={handleChange}
//                   required
//                 />
//               </Grid>
//             ))}
//             <Grid item xs={12} md={6}>
//               <StyledTextField
//                 fullWidth
//                 label="Password"
//                 name="password"
//                 type={showPassword ? 'text' : 'password'}
//                 value={formData.password}
//                 onChange={handleChange}
//                 required
//                 InputProps={{
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton onClick={() => setShowPassword(!showPassword)}>
//                         {showPassword ? <VisibilityOff /> : <Visibility />}
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//               />
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <StyledTextField
//                 fullWidth
//                 label="Confirm Password"
//                 name="confirm_password"
//                 type="password"
//                 value={formData.confirm_password}
//                 onChange={handleChange}
//                 required
//               />
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <StyledTextField
//                 fullWidth
//                 label="Date of Birth"
//                 name="date_of_birth"
//                 type="date"
//                 InputLabelProps={{ shrink: true }}
//                 value={formData.date_of_birth}
//                 onChange={handleChange}
//                 required
//               />
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <FormControl fullWidth>
//                 <InputLabel id="gender-label">Gender</InputLabel>
//                 <Select
//                   labelId="gender-label"
//                   name="gender"
//                   value={formData.gender}
//                   onChange={handleChange}
//                   required
//                 >
//                   <MenuItem value="Male">Male</MenuItem>
//                   <MenuItem value="Female">Female</MenuItem>
//                   <MenuItem value="Other">Other</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12}>
//               <FormControl fullWidth>
//                 <InputLabel id="communication-label">Preferred Communication</InputLabel>
//                 <Select
//                   labelId="communication-label"
//                   name="communication_preference"
//                   value={formData.communication_preference}
//                   onChange={handleChange}
//                 >
//                   <MenuItem value="Email">Email</MenuItem>
//                   <MenuItem value="Phone">Phone</MenuItem>
//                   <MenuItem value="SMS">SMS</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12}>
//               <FormControlLabel
//                 control={<Checkbox name="consent" checked={formData.consent} onChange={handleChange} />}
//                 label="I agree to the terms and conditions"
//               />
//             </Grid>
//             <Grid item xs={12}>
//               <RegisterButton type="submit" fullWidth disabled={loading}>
//                 {loading ? <CircularProgress size={24} /> : 'Register'}
//               </RegisterButton>
//             </Grid>
//           </Grid>
//         </form>
//       </StyledPaper>
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <Alert
//           onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//           severity={snackbar.severity}
//           sx={{ width: '100%' }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// // }
// import React, { useState } from 'react';
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   IconButton,
//   InputAdornment,
//   Paper,
//   Snackbar,
//   Alert,
//   CircularProgress,
//   Grid,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Checkbox,
//   FormControlLabel,
// } from '@mui/material';
// import { Visibility, VisibilityOff } from '@mui/icons-material';
// import { styled } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import Logo1 from '../../src/landpageimage/logo1.png';
// import Logo2 from '../../src/landpageimage/logo1.png';
// import Logo3 from '../../src/landpageimage/logo1.png';
// import Logo4 from '../../src/landpageimage/logo1.png';

// const themeColors = {
//   primary: '#00A76F',
//   gradient: 'linear-gradient(135deg, #00A76F 0%, #2196F3 100%)',
//   background: '#F3F4F6',
// };

// const StyledPaper = styled(Paper)(() => ({
//   display: 'flex',
//   flexDirection: 'column',
//   alignItems: 'center',
//   width: '90%',
//   maxWidth: '1400px',
//   margin: '0 auto',
//   borderRadius: '24px',
//   overflow: 'hidden',
//   padding: '24px',
//   backgroundColor: '#FFFFFF',
//   boxShadow: '0 20px 40px rgba(0, 167, 111, 0.15)',
// }));

// const LogoContainer = styled(Box)(() => ({
//   display: 'flex',
//   justifyContent: 'space-around',
//   alignItems: 'center',
//   width: '100%',
//   padding: '16px 0',
//   marginBottom: '24px',
// }));

// const LogoImage = styled('img')(() => ({
//   width: '100px',
//   height: 'auto',
// }));

// const StyledTextField = styled(TextField)(() => ({
//   '& .MuiOutlinedInput-root': {
//     borderRadius: '16px',
//     backgroundColor: '#F3F4F6',
//     '&:hover': {
//       backgroundColor: '#F9FAFB',
//     },
//     '&.Mui-focused fieldset': {
//       borderColor: themeColors.primary,
//     },
//   },
// }));

// const RegisterButton = styled(Button)(() => ({
//   backgroundColor: themeColors.primary,
//   color: 'white',
//   padding: '12px',
//   borderRadius: '16px',
//   fontWeight: 600,
//   '&:hover': {
//     backgroundColor: '#008F5D',
//   },
// }));

// export default function StudentRegister() {
//   const navigate = useNavigate();
//   const [showPassword, setShowPassword] = useState(false);
//   const [formData, setFormData] = useState({
//     full_name: '',
//     email: '',
//     password: '',
//     confirm_password: '',
//     phone_number: '',
//     address: '',
//     city: '',
//     state: '',
//     postal_code: '',
//     country: '',
//     date_of_birth: '',
//     gender: '',
//     institution: '',
//     field_of_study: '',
//     graduation_year: '',
//     role: 'Student',
//     communication_preference: 'Email',
//     consent: false,
//   });
//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//   const validate = () => {
//     const newErrors = {};

//     if (!/^[a-zA-Z ]+$/.test(formData.full_name)) {
//       newErrors.full_name = 'Full Name should contain only letters and spaces';
//     }
//     if (!/^[0-9]{10}$/.test(formData.phone_number)) {
//       newErrors.phone_number = 'Phone Number should be exactly 10 digits';
//     }
//     if (formData.password !== formData.confirm_password) {
//       newErrors.confirm_password = 'Passwords do not match';
//     }
//     if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
//       newErrors.email = 'Invalid email address';
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: type === 'checkbox' ? checked : value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;
//     setLoading(true);
//     try {
//       const response = await fetch('http://65.0.71.177:8000/api/register_stud/', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(formData),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         setSnackbar({ open: true, message: 'Registration successful!', severity: 'success' });
//         setTimeout(() => navigate('/Login'), 2000);
//       } else {
//         setSnackbar({ open: true, message: data.msg || 'Registration failed!', severity: 'error' });
//       }
//     } catch (error) {
//       setSnackbar({ open: true, message: 'An error occurred. Please try again.', severity: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//         justifyContent: 'center',
//         backgroundColor: themeColors.background,
//       }}
//     >
//       <StyledPaper>
//         <LogoContainer>
//           <LogoImage src={Logo1} alt="Logo 1" />
//           <LogoImage src={Logo2} alt="Logo 2" />
//           <LogoImage src={Logo3} alt="Logo 3" />
//           <LogoImage src={Logo4} alt="Logo 4" />
//         </LogoContainer>

//         <Typography variant="h4" fontWeight="bold" mb={2} sx={{ color: themeColors.primary }}>
//           Welcome, Future Achiever!
//         </Typography>
//         <Typography variant="body1" mb={3}>
//           Start your journey by registering below.
//         </Typography>

//         <form onSubmit={handleSubmit} style={{ width: '100%' }}>
//           <Grid container spacing={2}>
//             {Object.entries({
//               full_name: 'Full Name',
//               email: 'Email',
//               phone_number: 'Phone Number',
//               address: 'Address',
//               city: 'City',
//               state: 'State',
//               postal_code: 'Postal Code',
//               country: 'Country',
//               institution: 'Institution',
//               field_of_study: 'Field of Study',
//               graduation_year: 'Graduation Year',
//             }).map(([name, label]) => (
//               <Grid item xs={12} md={6} key={name}>
//                 <StyledTextField
//                   fullWidth
//                   label={label}
//                   name={name}
//                   type={name === 'graduation_year' ? 'number' : 'text'}
//                   value={formData[name]}
//                   onChange={handleChange}
//                   required
//                   error={!!errors[name]}
//                   helperText={errors[name]}
//                 />
//               </Grid>
//             ))}
//             <Grid item xs={12} md={6}>
//               <StyledTextField
//                 fullWidth
//                 label="Password"
//                 name="password"
//                 type={showPassword ? 'text' : 'password'}
//                 value={formData.password}
//                 onChange={handleChange}
//                 required
//                 error={!!errors.password}
//                 helperText={errors.password}
//                 InputProps={{
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton onClick={() => setShowPassword(!showPassword)}>
//                         {showPassword ? <VisibilityOff /> : <Visibility />}
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//               />
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <StyledTextField
//                 fullWidth
//                 label="Confirm Password"
//                 name="confirm_password"
//                 type="password"
//                 value={formData.confirm_password}
//                 onChange={handleChange}
//                 required
//                 error={!!errors.confirm_password}
//                 helperText={errors.confirm_password}
//               />
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <StyledTextField
//                 fullWidth
//                 label="Date of Birth"
//                 name="date_of_birth"
//                 type="date"
//                 InputLabelProps={{ shrink: true }}
//                 value={formData.date_of_birth}
//                 onChange={handleChange}
//                 required
//               />
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <FormControl fullWidth>
//                 <InputLabel id="gender-label">Gender</InputLabel>
//                 <Select
//                   labelId="gender-label"
//                   name="gender"
//                   value={formData.gender}
//                   onChange={handleChange}
//                   required
//                 >
//                   <MenuItem value="Male">Male</MenuItem>
//                   <MenuItem value="Female">Female</MenuItem>
//                   <MenuItem value="Other">Other</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12}>
//               <FormControl fullWidth>
//                 <InputLabel id="communication-label">Preferred Communication</InputLabel>
//                 <Select
//                   labelId="communication-label"
//                   name="communication_preference"
//                   value={formData.communication_preference}
//                   onChange={handleChange}
//                 >
//                   <MenuItem value="Email">Email</MenuItem>
//                   <MenuItem value="Phone">Phone</MenuItem>
//                   <MenuItem value="SMS">SMS</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12}>
//               <FormControlLabel
//                 control={<Checkbox name="consent" checked={formData.consent} onChange={handleChange} />}
//                 label="I agree to the terms and conditions"
//               />
//             </Grid>
//             <Grid item xs={12}>
//               <RegisterButton type="submit" fullWidth disabled={loading}>
//                 {loading ? <CircularProgress size={24} /> : 'Register'}
//               </RegisterButton>
//             </Grid>
//           </Grid>
//         </form>
//       </StyledPaper>
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <Alert
//           onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//           severity={snackbar.severity}
//           sx={{ width: '100%' }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// }

// import React, { useState } from 'react';
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   IconButton,
//   InputAdornment,
//   Paper,
//   Snackbar,
//   Alert,
//   CircularProgress,
//   Grid,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Checkbox,
//   FormControlLabel,
// } from '@mui/material';
// import { Visibility, VisibilityOff } from '@mui/icons-material';
// import { styled } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import Logo1 from '../../src/landpageimage/logo1.png';
// import Logo2 from '../../src/landpageimage/logo1.png';
// import Logo3 from '../../src/landpageimage/logo1.png';
// import Logo4 from '../../src/landpageimage/logo1.png';

// const themeColors = {
//   primary: '#00A76F',
//   gradient: 'linear-gradient(135deg, #00A76F 0%, #2196F3 100%)',
//   background: '#F3F4F6',
// };

// const StyledPaper = styled(Paper)(() => ({
//   display: 'flex',
//   flexDirection: 'column',
//   alignItems: 'center',
//   width: '90%',
//   maxWidth: '1400px',
//   margin: '0 auto',
//   borderRadius: '24px',
//   overflow: 'hidden',
//   padding: '24px',
//   backgroundColor: '#FFFFFF',
//   boxShadow: '0 20px 40px rgba(0, 167, 111, 0.15)',
// }));

// const LogoContainer = styled(Box)(() => ({
//   display: 'flex',
//   justifyContent: 'space-around',
//   alignItems: 'center',
//   width: '100%',
//   padding: '16px 0',
//   marginBottom: '24px',
// }));

// const LogoImage = styled('img')(() => ({
//   width: '100px',
//   height: 'auto',
// }));

// const StyledTextField = styled(TextField)(() => ({
//   '& .MuiOutlinedInput-root': {
//     borderRadius: '16px',
//     backgroundColor: '#F3F4F6',
//     '&:hover': {
//       backgroundColor: '#F9FAFB',
//     },
//     '&.Mui-focused fieldset': {
//       borderColor: themeColors.primary,
//     },
//   },
// }));

// const RegisterButton = styled(Button)(() => ({
//   backgroundColor: themeColors.primary,
//   color: 'white',
//   padding: '12px',
//   borderRadius: '16px',
//   fontWeight: 600,
//   '&:hover': {
//     backgroundColor: '#008F5D',
//   },
// }));

// export default function StudentRegister() {
//   const navigate = useNavigate();
//   const [showPassword, setShowPassword] = useState(false);
//   const [formData, setFormData] = useState({
//     full_name: '',
//     email: '',
//     password: '',
//     confirm_password: '',
//     phone_number: '',
//     address: '',
//     city: '',
//     state: '',
//     postal_code: '',
//     country: '',
//     date_of_birth: '',
//     gender: '',
//     institution: '',
//     field_of_study: '',
//     graduation_year: '',
//     role: 'Student',
//     communication_preference: 'Email',
//     consent: false,
//   });
//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//   const validate = () => {
//     const newErrors = {};

//     if (!/^[a-zA-Z ]+$/.test(formData.full_name)) {
//       newErrors.full_name = 'Full Name should contain only letters and spaces';
//     }
//     if (!/^[0-9]{10}$/.test(formData.phone_number)) {
//       newErrors.phone_number = 'Phone Number should be exactly 10 digits';
//     }
//     if (!/^[0-9]{6}$/.test(formData.postal_code)) {
//       newErrors.postal_code = 'Postal Code should be exactly 6 digits';
//     }
//     if (!/^[0-9]+$/.test(formData.graduation_year)) {
//       newErrors.graduation_year = 'Graduation Year should only contain numbers';
//     }
//     if (formData.password !== formData.confirm_password) {
//       newErrors.confirm_password = 'Passwords do not match';
//     }
//     if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
//       newErrors.email = 'Invalid email address';
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: type === 'checkbox' ? checked : value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;
//     setLoading(true);
//     try {
//       const response = await fetch('http://65.0.71.177:8000/api/register_stud/', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(formData),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         setSnackbar({ open: true, message: 'Registration successful!', severity: 'success' });
//         setTimeout(() => navigate('/Login'), 2000);
//       } else {
//         setSnackbar({ open: true, message: data.msg || 'Registration failed!', severity: 'error' });
//       }
//     } catch (error) {
//       setSnackbar({ open: true, message: 'An error occurred. Please try again.', severity: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//         justifyContent: 'center',
//         backgroundColor: themeColors.background,
//       }}
//     >
//       <StyledPaper>
//         <LogoContainer>
//           <LogoImage src={Logo1} alt="Logo 1" />
//           <LogoImage src={Logo2} alt="Logo 2" />
//           <LogoImage src={Logo3} alt="Logo 3" />
//           <LogoImage src={Logo4} alt="Logo 4" />
//         </LogoContainer>

//         <Typography variant="h4" fontWeight="bold" mb={2} sx={{ color: themeColors.primary }}>
//           Welcome, Future Achiever!
//         </Typography>
//         <Typography variant="body1" mb={3}>
//           Start your journey by registering below.
//         </Typography>

//         <form onSubmit={handleSubmit} style={{ width: '100%' }}>
//           <Grid container spacing={2}>
//             {Object.entries({
//               full_name: 'Full Name',
//               email: 'Email',
//               phone_number: 'Phone Number',
//               address: 'Address',
//               city: 'City',
//               state: 'State',
//               postal_code: 'Postal Code',
//               country: 'Country',
//               institution: 'Institution',
//               field_of_study: 'Field of Study',
//               graduation_year: 'Graduation Year',
//             }).map(([name, label]) => (
//               <Grid item xs={12} md={6} key={name}>
//                 <StyledTextField
//                   fullWidth
//                   label={label}
//                   name={name}
//                   type={name === 'graduation_year' || name === 'postal_code' ? 'number' : 'text'}
//                   value={formData[name]}
//                   onChange={handleChange}
//                   required
//                   error={!!errors[name]}
//                   helperText={errors[name]}
//                 />
//               </Grid>
//             ))}
//             <Grid item xs={12} md={6}>
//               <StyledTextField
//                 fullWidth
//                 label="Password"
//                 name="password"
//                 type={showPassword ? 'text' : 'password'}
//                 value={formData.password}
//                 onChange={handleChange}
//                 required
//                 error={!!errors.password}
//                 helperText={errors.password}
//                 InputProps={{
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton onClick={() => setShowPassword(!showPassword)}>
//                         {showPassword ? <VisibilityOff /> : <Visibility />}
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//               />
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <StyledTextField
//                 fullWidth
//                 label="Confirm Password"
//                 name="confirm_password"
//                 type="password"
//                 value={formData.confirm_password}
//                 onChange={handleChange}
//                 required
//                 error={!!errors.confirm_password}
//                 helperText={errors.confirm_password}
//               />
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <StyledTextField
//                 fullWidth
//                 label="Date of Birth"
//                 name="date_of_birth"
//                 type="date"
//                 InputLabelProps={{ shrink: true }}
//                 value={formData.date_of_birth}
//                 onChange={handleChange}
//                 required
//               />
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <FormControl fullWidth>
//                 <InputLabel id="gender-label">Gender</InputLabel>
//                 <Select
//                   labelId="gender-label"
//                   name="gender"
//                   value={formData.gender}
//                   onChange={handleChange}
//                   required
//                 >
//                   <MenuItem value="Male">Male</MenuItem>
//                   <MenuItem value="Female">Female</MenuItem>
//                   <MenuItem value="Other">Other</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12}>
//               <FormControl fullWidth>
//                 <InputLabel id="communication-label">Preferred Communication</InputLabel>
//                 <Select
//                   labelId="communication-label"
//                   name="communication_preference"
//                   value={formData.communication_preference}
//                   onChange={handleChange}
//                 >
//                   <MenuItem value="Email">Email</MenuItem>
//                   <MenuItem value="Phone">Phone</MenuItem>
//                   <MenuItem value="SMS">SMS</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12}>
//               <FormControlLabel
//                 control={<Checkbox name="consent" checked={formData.consent} onChange={handleChange} />}
//                 label="I agree to the terms and conditions"
//               />
//             </Grid>
//             <Grid item xs={12}>
//               <RegisterButton type="submit" fullWidth disabled={loading}>
//                 {loading ? <CircularProgress size={24} /> : 'Register'}
//               </RegisterButton>
//             </Grid>
//           </Grid>
//         </form>
//       </StyledPaper>
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <Alert
//           onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//           severity={snackbar.severity}
//           sx={{ width: '100%' }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// }

// import React, { useState } from 'react';
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   IconButton,
//   InputAdornment,
//   Paper,
//   Snackbar,
//   Alert,
//   CircularProgress,
//   Grid,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Checkbox,
//   FormControlLabel,
// } from '@mui/material';
// import { Visibility, VisibilityOff } from '@mui/icons-material';
// import { styled } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import Logo1 from '../../src/landpageimage/logo1.png';
// import Logo2 from '../../src/landpageimage/logo1.png';
// import Logo3 from '../../src/landpageimage/logo1.png';
// import Logo4 from '../../src/landpageimage/logo1.png';

// const themeColors = {
//   primary: '#00A76F',
//   gradient: 'linear-gradient(135deg, #00A76F 0%, #2196F3 100%)',
//   background: '#F3F4F6',
// };

// const StyledPaper = styled(Paper)(() => ({
//   display: 'flex',
//   flexDirection: 'column',
//   alignItems: 'center',
//   width: '90%',
//   maxWidth: '1400px',
//   margin: '0 auto',
//   borderRadius: '24px',
//   overflow: 'hidden',
//   padding: '24px',
//   backgroundColor: '#FFFFFF',
//   boxShadow: '0 20px 40px rgba(0, 167, 111, 0.15)',
// }));

// const LogoContainer = styled(Box)(() => ({
//   display: 'grid',
//   gridTemplateColumns: 'repeat(4, 1fr)',
//   gap: '16px',
//   justifyContent: 'center',
//   alignItems: 'center',
//   width: '100%',
//   padding: '16px 0',
//   marginBottom: '24px',
//   '@media (max-width: 600px)': {
//     gridTemplateColumns: 'repeat(2, 1fr)',
//   },
// }));

// const LogoImage = styled('img')(() => ({
//   width: '100px',
//   height: 'auto',
// }));

// const StyledTextField = styled(TextField)(() => ({
//   '& .MuiOutlinedInput-root': {
//     borderRadius: '16px',
//     backgroundColor: '#F3F4F6',
//     '&:hover': {
//       backgroundColor: '#F9FAFB',
//     },
//     '&.Mui-focused fieldset': {
//       borderColor: themeColors.primary,
//     },
//   },
// }));

// const RegisterButton = styled(Button)(() => ({
//   backgroundColor: themeColors.primary,
//   color: 'white',
//   padding: '12px',
//   borderRadius: '16px',
//   fontWeight: 600,
//   '&:hover': {
//     backgroundColor: '#008F5D',
//   },
// }));

// export default function StudentRegister() {
//   const navigate = useNavigate();
//   const [showPassword, setShowPassword] = useState(false);
//   const [formData, setFormData] = useState({
//     full_name: '',
//     email: '',
//     password: '',
//     confirm_password: '',
//     phone_number: '',
//     address: '',
//     city: '',
//     state: '',
//     postal_code: '',
//     country: '',
//     date_of_birth: '',
//     gender: '',
//     institution: '',
//     field_of_study: '',
//     graduation_year: '',
//     role: 'Student',
//     communication_preference: 'Email',
//     consent: false,
//   });
//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//   const validate = () => {
//     const newErrors = {};

//     if (!/^[a-zA-Z ]+$/.test(formData.full_name)) {
//       newErrors.full_name = 'Full Name should contain only letters and spaces';
//     }
//     if (!/^[0-9]{10}$/.test(formData.phone_number)) {
//       newErrors.phone_number = 'Phone Number should be exactly 10 digits';
//     }
//     if (!/^[0-9]{6}$/.test(formData.postal_code)) {
//       newErrors.postal_code = 'Postal Code should be exactly 6 digits';
//     }
//     if (!/^[0-9]+$/.test(formData.graduation_year)) {
//       newErrors.graduation_year = 'Graduation Year should only contain numbers';
//     }
//     if (formData.password !== formData.confirm_password) {
//       newErrors.confirm_password = 'Passwords do not match';
//     }
//     if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
//       newErrors.email = 'Invalid email address';
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: type === 'checkbox' ? checked : value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;
//     setLoading(true);
//     try {
//       const response = await fetch('http://65.0.71.177:8000/api/register_stud/', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(formData),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         setSnackbar({ open: true, message: 'Registration successful!', severity: 'success' });
//         setTimeout(() => navigate('/Login'), 2000);
//       } else {
//         setSnackbar({ open: true, message: data.msg || 'Registration failed!', severity: 'error' });
//       }
//     } catch (error) {
//       setSnackbar({ open: true, message: 'An error occurred. Please try again.', severity: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//         justifyContent: 'center',
//         backgroundColor: themeColors.background,
//       }}
//     >
//       <StyledPaper>
//         <LogoContainer>
//           <LogoImage src={Logo1} alt="Logo 1" />
//           <LogoImage src={Logo2} alt="Logo 2" />
//           <LogoImage src={Logo3} alt="Logo 3" />
//           <LogoImage src={Logo4} alt="Logo 4" />
//         </LogoContainer>

//         <Typography variant="h4" fontWeight="bold" mb={2} sx={{ color: themeColors.primary }}>
//           Welcome, Future Achiever!
//         </Typography>
//         <Typography variant="body1" mb={3}>
//           Start your journey by registering below.
//         </Typography>

//         <form onSubmit={handleSubmit} style={{ width: '100%' }}>
//           <Grid container spacing={2}>
//             {Object.entries({
//               full_name: 'Full Name',
//               email: 'Email',
//               phone_number: 'Phone Number',
//               address: 'Address',
//               city: 'City',
//               state: 'State',
//               postal_code: 'Postal Code',
//               country: 'Country',
//               institution: 'Institution',
//               field_of_study: 'Field of Study',
//               graduation_year: 'Graduation Year',
//             }).map(([name, label]) => (
//               <Grid item xs={12} md={4} key={name}>
//                 <StyledTextField
//                   fullWidth
//                   label={label}
//                   name={name}
//                   type={name === 'graduation_year' || name === 'postal_code' ? 'number' : 'text'}
//                   value={formData[name]}
//                   onChange={handleChange}
//                   required
//                   error={!!errors[name]}
//                   helperText={errors[name]}
//                 />
//               </Grid>
//             ))}
//             <Grid item xs={12} md={4}>
//               <StyledTextField
//                 fullWidth
//                 label="Password"
//                 name="password"
//                 type={showPassword ? 'text' : 'password'}
//                 value={formData.password}
//                 onChange={handleChange}
//                 required
//                 error={!!errors.password}
//                 helperText={errors.password}
//                 InputProps={{
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton onClick={() => setShowPassword(!showPassword)}>
//                         {showPassword ? <VisibilityOff /> : <Visibility />}
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//               />
//             </Grid>
//             <Grid item xs={12} md={4}>
//               <StyledTextField
//                 fullWidth
//                 label="Confirm Password"
//                 name="confirm_password"
//                 type="password"
//                 value={formData.confirm_password}
//                 onChange={handleChange}
//                 required
//                 error={!!errors.confirm_password}
//                 helperText={errors.confirm_password}
//               />
//             </Grid>
//             <Grid item xs={12} md={4}>
//               <StyledTextField
//                 fullWidth
//                 label="Date of Birth"
//                 name="date_of_birth"
//                 type="date"
//                 InputLabelProps={{ shrink: true }}
//                 value={formData.date_of_birth}
//                 onChange={handleChange}
//                 required
//               />
//             </Grid>
//             <Grid item xs={12} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel id="gender-label">Gender</InputLabel>
//                 <Select
//                   labelId="gender-label"
//                   name="gender"
//                   value={formData.gender}
//                   onChange={handleChange}
//                   required
//                 >
//                   <MenuItem value="Male">Male</MenuItem>
//                   <MenuItem value="Female">Female</MenuItem>
//                   <MenuItem value="Other">Other</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel id="communication-label">Preferred Communication</InputLabel>
//                 <Select
//                   labelId="communication-label"
//                   name="communication_preference"
//                   value={formData.communication_preference}
//                   onChange={handleChange}
//                 >
//                   <MenuItem value="Email">Email</MenuItem>
//                   <MenuItem value="Phone">Phone</MenuItem>
//                   <MenuItem value="SMS">SMS</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12}>
//               <FormControlLabel
//                 control={<Checkbox name="consent" checked={formData.consent} onChange={handleChange} />}
//                 label="I agree to the terms and conditions"
//               />
//             </Grid>
//             <Grid item xs={12}>
//               <RegisterButton type="submit" fullWidth disabled={loading}>
//                 {loading ? <CircularProgress size={24} /> : 'Register'}
//               </RegisterButton>
//             </Grid>
//           </Grid>
//         </form>
//       </StyledPaper>
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <Alert
//           onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//           severity={snackbar.severity}
//           sx={{ width: '100%' }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// // }
// import React, { useState } from 'react';
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   IconButton,
//   InputAdornment,
//   Paper,
//   Snackbar,
//   Alert,
//   CircularProgress,
//   Grid,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Checkbox,
//   FormControlLabel,
// } from '@mui/material';
// import { Visibility, VisibilityOff } from '@mui/icons-material';
// import { styled } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import Logo1 from '../../src/landpageimage/logo1.png';
// import Logo2 from '../../src/landpageimage/TDTLLogo.png';
// import Logo3 from '../../src/landpageimage/logo2.jpg';
// import Logo4 from '../../src/landpageimage/logo1.png';

// const themeColors = {
//   primary: '#00A76F',
//   gradient: 'linear-gradient(135deg, #00A76F 0%, #2196F3 100%)',
//   background: 'linear-gradient(135deg, #1A2A6C 0%, #B21F1F 50%, #FDBB2D 100%)',
// };

// const StyledPaper = styled(Paper)(() => ({
//   display: 'flex',
//   flexDirection: 'column',
//   alignItems: 'center',
//   width: '90%',
//   maxWidth: '1400px',
//   margin: '0 auto',
//   borderRadius: '24px',
//   overflow: 'hidden',
//   padding: '24px',
//   backgroundColor: '#FFFFFF',
//   boxShadow: '0 20px 40px rgba(0, 167, 111, 0.15)',
// }));

// const LogoContainer = styled(Box)(() => ({
//   display: 'grid',
//   gridTemplateColumns: 'repeat(4, 1fr)',
//   gap: '16px',
//   justifyContent: 'center',
//   alignItems: 'center',
//   width: '100%',
//   padding: '16px 0',
//   marginBottom: '24px',
//   '@media (max-width: 600px)': {
//     gridTemplateColumns: 'repeat(2, 1fr)',
//   },
// }));

// const LogoImage = styled('img')(() => ({
//   width: '140px',
//   height: '100px',
// }));

// const StyledTextField = styled(TextField)(() => ({
//   '& .MuiOutlinedInput-root': {
//     borderRadius: '16px',
//     backgroundColor: '#F3F4F6',
//     '&:hover': {
//       backgroundColor: '#F9FAFB',
//     },
//     '&.Mui-focused fieldset': {
//       borderColor: themeColors.primary,
//     },
//   },
// }));

// const RegisterButton = styled(Button)(() => ({
//   backgroundColor: themeColors.primary,
//   color: 'white',
//   padding: '12px',
//   borderRadius: '16px',
//   fontWeight: 600,
//   '&:hover': {
//     backgroundColor: '#008F5D',
//   },
// }));

// export default function StudentRegister() {
//   const navigate = useNavigate();
//   const [showPassword, setShowPassword] = useState(false);
//   const [formData, setFormData] = useState({
//     full_name: '',
//     email: '',
//     password: '',
//     confirm_password: '',
//     phone_number: '',
//     address: '',
//     city: '',
//     state: '',
//     postal_code: '',
//     country: '',
//     date_of_birth: '',
//     gender: '',
//     institution: '',
//     field_of_study: '',
//     graduation_year: '',
//     role: 'Student',
//     communication_preference: 'Email',
//     consent: false,
//   });
//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//   const validate = () => {
//     const newErrors = {};

//     if (!/^[a-zA-Z ]+$/.test(formData.full_name)) {
//       newErrors.full_name = 'Full Name should contain only letters and spaces';
//     }
//     if (!/^[0-9]{10}$/.test(formData.phone_number)) {
//       newErrors.phone_number = 'Phone Number should be exactly 10 digits';
//     }
//     if (!/^[0-9]{6}$/.test(formData.postal_code)) {
//       newErrors.postal_code = 'Postal Code should be exactly 6 digits';
//     }
//     if (!/^[0-9]+$/.test(formData.graduation_year)) {
//       newErrors.graduation_year = 'Graduation Year should only contain numbers';
//     }
//     if (formData.password !== formData.confirm_password) {
//       newErrors.confirm_password = 'Passwords do not match';
//     }
//     if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
//       newErrors.email = 'Invalid email address';
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: type === 'checkbox' ? checked : value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;
//     setLoading(true);
//     try {
//       const response = await fetch('http://65.0.71.177:8000/api/register_stud/', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(formData),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         setSnackbar({ open: true, message: 'Registration successful!', severity: 'success' });
//         setTimeout(() => navigate('/Login'), 2000);
//       } else {
//         setSnackbar({ open: true, message: data.msg || 'Registration failed!', severity: 'error' });
//       }
//     } catch (error) {
//       setSnackbar({ open: true, message: 'An error occurred. Please try again.', severity: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//         justifyContent: 'center',
//         background: themeColors.background,
//       }}
//     >
//       <StyledPaper>
//         <LogoContainer>
//           <LogoImage src={Logo1} alt="Logo 1" />
//           <LogoImage src={Logo2} alt="Logo 2" />
//           <LogoImage src={Logo3} alt="Logo 3" />
//           <LogoImage src={Logo4} alt="Logo 4" />
//         </LogoContainer>

//         <Typography variant="h4" fontWeight="bold" mb={2} sx={{ color: themeColors.primary }}>
//           Welcome, Future Achiever!
//         </Typography>
//         <Typography variant="body1" mb={3}>
//           Start your journey by registering below.
//         </Typography>

//         <form onSubmit={handleSubmit} style={{ width: '100%' }}>
//           <Grid container spacing={2}>
//             {Object.entries({
//               full_name: 'Full Name',
//               email: 'Email',
//               phone_number: 'Phone Number',
//               address: 'Address',
//               city: 'City',
//               state: 'State',
//               postal_code: 'Postal Code',
//               country: 'Country',
//               institution: 'Institution',
//               field_of_study: 'Field of Study',
//               graduation_year: 'Graduation Year',
//             }).map(([name, label]) => (
//               <Grid item xs={12} md={4} key={name}>
//                 <StyledTextField
//                   fullWidth
//                   label={label}
//                   name={name}
//                   type={name === 'graduation_year' || name === 'postal_code' ? 'number' : 'text'}
//                   value={formData[name]}
//                   onChange={handleChange}
//                   required
//                   error={!!errors[name]}
//                   helperText={errors[name]}
//                 />
//               </Grid>
//             ))}
//             <Grid item xs={12} md={4}>
//               <StyledTextField
//                 fullWidth
//                 label="Password"
//                 name="password"
//                 type={showPassword ? 'text' : 'password'}
//                 value={formData.password}
//                 onChange={handleChange}
//                 required
//                 error={!!errors.password}
//                 helperText={errors.password}
//                 InputProps={{
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton onClick={() => setShowPassword(!showPassword)}>
//                         {showPassword ? <VisibilityOff /> : <Visibility />}
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//               />
//             </Grid>
//             <Grid item xs={12} md={4}>
//               <StyledTextField
//                 fullWidth
//                 label="Confirm Password"
//                 name="confirm_password"
//                 type="password"
//                 value={formData.confirm_password}
//                 onChange={handleChange}
//                 required
//                 error={!!errors.confirm_password}
//                 helperText={errors.confirm_password}
//               />
//             </Grid>
//             <Grid item xs={12} md={4}>
//               <StyledTextField
//                 fullWidth
//                 label="Date of Birth"
//                 name="date_of_birth"
//                 type="date"
//                 InputLabelProps={{ shrink: true }}
//                 value={formData.date_of_birth}
//                 onChange={handleChange}
//                 required
//               />
//             </Grid>
//             <Grid item xs={12} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel id="gender-label">Gender</InputLabel>
//                 <Select
//                   labelId="gender-label"
//                   name="gender"
//                   value={formData.gender}
//                   onChange={handleChange}
//                   required
//                 >
//                   <MenuItem value="Male">Male</MenuItem>
//                   <MenuItem value="Female">Female</MenuItem>
//                   <MenuItem value="Other">Other</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel id="communication-label">Preferred Communication</InputLabel>
//                 <Select
//                   labelId="communication-label"
//                   name="communication_preference"
//                   value={formData.communication_preference}
//                   onChange={handleChange}
//                 >
//                   <MenuItem value="Email">Email</MenuItem>
//                   <MenuItem value="Phone">Phone</MenuItem>
//                   <MenuItem value="SMS">SMS</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12}>
//               <FormControlLabel
//                 control={<Checkbox name="consent" checked={formData.consent} onChange={handleChange} />}
//                 label="I agree to the terms and conditions"
//               />
//             </Grid>
//             <Grid item xs={12}>
//               <RegisterButton type="submit" fullWidth disabled={loading}>
//                 {loading ? <CircularProgress size={24} /> : 'Register'}
//               </RegisterButton>
//             </Grid>
//           </Grid>
//         </form>
//       </StyledPaper>
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <Alert
//           onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//           severity={snackbar.severity}
//           sx={{ width: '100%' }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// }

// import React, { useState } from 'react';
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   IconButton,
//   InputAdornment,
//   Paper,
//   Snackbar,
//   Alert,
//   CircularProgress,
//   Grid,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Checkbox,
//   FormControlLabel,
// } from '@mui/material';
// import { Visibility, VisibilityOff } from '@mui/icons-material';
// import { styled } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import Logo1 from '../../src/landpageimage/logo1.png';
// import Logo2 from '../../src/landpageimage/TDTLLogo.png';
// import Logo3 from '../../src/landpageimage/logo2.jpg';
// import Logo4 from '../../src/landpageimage/logo1.png';

// const themeColors = {
//   primary: '#00A76F',
//   gradient: 'linear-gradient(135deg, #00A76F 0%, #2196F3 100%)',
//   background: 'linear-gradient(135deg, #1A2A6C 0%, #B21F1F 50%, #FDBB2D 100%)',
// };

// const StyledPaper = styled(Paper)(() => ({
//   display: 'flex',
//   flexDirection: 'column',
//   alignItems: 'center',
//   width: '70%',
//   height:'80vh',
//   maxWidth: '1400px',
//   margin: '0 auto',
//   borderRadius: '24px',
//   height: 'auto', 
//   overflow: 'hidden',
//   padding: '24px',
//   backgroundColor: '#FFFFFF',
//   boxShadow: '0 20px 40px rgba(0, 167, 111, 0.15)',
// }));

// const LogoContainer = styled(Box)(() => ({
//   display: 'grid',
//   gridTemplateColumns: 'repeat(4, 1fr)', // Default for larger screens
//   gap: '16px',
//   justifyContent: 'center',
//   alignItems: 'center',
//   width: '100%',
//   padding: '16px 0',
//   marginBottom: '0px',
//   '@media (max-width: 600px)': {
//     gridTemplateColumns: 'repeat(2, 1fr)', // Change to 2x2 grid on mobile
//   },
// }));

// const LogoImage = styled('img')(() => ({
//   maxWidth: '150px', // Adjust size for responsiveness
//   maxHeight: '120px',
//   objectFit: 'contain',
//   margin: '0 auto',
// }));



// const StyledTextField = styled(TextField)(() => ({
//   '& .MuiOutlinedInput-root': {
//     borderRadius: '16px',
//     backgroundColor: '#F3F4F6',
//     '&:hover': {
//       backgroundColor: '#F9FAFB',
//     },
//     '&.Mui-focused fieldset': {
//       borderColor: themeColors.primary,
//     },
//   },
// }));

// const RegisterButton = styled(Button)(() => ({
//   backgroundColor: themeColors.primary,
//   color: 'white',
//   padding: '12px',
//   borderRadius: '16px',
//   fontWeight: 600,
//   '&:hover': {
//     backgroundColor: '#008F5D',
//   },
// }));

// export default function StudentRegister() {
//   const navigate = useNavigate();
//   const [showPassword, setShowPassword] = useState(false);
//   const [formData, setFormData] = useState({
//     full_name: '',
//     email: '',
//     password: '',
//     confirm_password: '',
//     phone_number: '',
//     address: '',
//     city: '',
//     state: '',
//     postal_code: '',
//     country: '',
//     date_of_birth: '',
//     gender: '',
//     institution: '',
//     field_of_study: '',
//     graduation_year: '',
//     role: 'Student',
//     communication_preference: 'Email',
//     consent: false,
//   });
//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//   const validate = () => {
//     const newErrors = {};

//     if (!/^[a-zA-Z ]+$/.test(formData.full_name)) {
//       newErrors.full_name = 'Full Name should contain only letters and spaces';
//     }
//     if (!/^[0-9]{10}$/.test(formData.phone_number)) {
//       newErrors.phone_number = 'Phone Number should be exactly 10 digits';
//     }
//     if (!/^[0-9]{6}$/.test(formData.postal_code)) {
//       newErrors.postal_code = 'Postal Code should be exactly 6 digits';
//     }
//     if (!/^[0-9]+$/.test(formData.graduation_year)) {
//       newErrors.graduation_year = 'Graduation Year should only contain numbers';
//     }
//     if (formData.password !== formData.confirm_password) {
//       newErrors.confirm_password = 'Passwords do not match';
//     }
//     if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
//       newErrors.email = 'Invalid email address';
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: type === 'checkbox' ? checked : value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;
//     setLoading(true);
//     try {
//       const response = await fetch('http://65.0.71.177:8000/api/register_stud/', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(formData),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         setSnackbar({ open: true, message: 'Registration successful!', severity: 'success' });
//         setTimeout(() => navigate('/Login'), 2000);
//       } else {
//         setSnackbar({ open: true, message: data.msg || 'Registration failed!', severity: 'error' });
//       }
//     } catch (error) {
//       setSnackbar({ open: true, message: 'An error occurred. Please try again.', severity: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box
//     sx={{
//       minHeight: '100vh',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center', // Ensures centering
//       background: themeColors.background,
//       padding: '24px', // Add some padding to avoid content touching screen edges
//     }}
//     >
//       <StyledPaper>
//         <LogoContainer>
//           <LogoImage src={Logo1} alt="Logo 1" />
//           <LogoImage src={Logo2} alt="Logo 2" />
//           <LogoImage src={Logo3} alt="Logo 3" />
//           <LogoImage src={Logo4} alt="Logo 4" />
//         </LogoContainer>

//         <Typography
//   variant="h4"
//   fontWeight="bold"
//   mb={5}
//   sx={{
//     color: 'transparent',
//     backgroundImage: themeColors.gradient,
//     backgroundClip: 'text',
//     WebkitBackgroundClip: 'text',
//     textAlign: 'center',
//     fontSize: '2rem',
//     transition: 'transform 0.3s ease, opacity 0.3s ease',
//     cursor: 'pointer',
//     animation: 'pulse 2s infinite',
//     '@keyframes pulse': {
//       '0%': { transform: 'scale(1)', opacity: 1 },
//       '50%': { transform: 'scale(1.05)', opacity: 0.9 },
//       '100%': { transform: 'scale(1)', opacity: 1 },
//     },
//     '&:hover': {
//       transform: 'scale(1.1)',
//       opacity: 1,
//     },
//   }}
// >
//   "Empower Your Journey – Register Today to Become a Future Entrepreneur!"
// </Typography>

        

//         <form onSubmit={handleSubmit} style={{ width: '100%' }}>
//           <Grid container spacing={2}>
//             {Object.entries({
//               full_name: 'Full Name',
//               email: 'Email',
//               password:'password',
//               phone_number: 'Phone Number',
//               address: 'Address',
//               city: 'City',
//               state: 'State',
//               postal_code: 'Postal Code',
//               country: 'Country',
//               institution: 'Institution',
//               field_of_study: 'Field of Study',
//               graduation_year: 'Graduation Year',
//             }).map(([name, label]) => (
//               <Grid item xs={12} md={4} key={name}>
//                 <StyledTextField
//                   fullWidth
//                   label={label}
//                   name={name}
//                   type={name === 'graduation_year' || name === 'postal_code' ? 'number' : 'text'}
//                   value={formData[name]}
//                   onChange={handleChange}
//                   required
//                   error={!!errors[name]}
//                   helperText={errors[name]}
//                 />
//               </Grid>
//             ))}
//             <Grid item xs={12} md={4}>
//               <StyledTextField
//                 fullWidth
//                 label="Password"
//                 name="password"
//                 type={showPassword ? 'text' : 'password'}
//                 value={formData.password}
//                 onChange={handleChange}
//                 required
//                 error={!!errors.password}
//                 helperText={errors.password}
//                 InputProps={{
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton onClick={() => setShowPassword(!showPassword)}>
//                         {showPassword ? <VisibilityOff /> : <Visibility />}
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//               />
//             </Grid>
//             <Grid item xs={12} md={4}>
//               <StyledTextField
//                 fullWidth
//                 label="Confirm Password"
//                 name="confirm_password"
//                 type="password"
//                 value={formData.confirm_password}
//                 onChange={handleChange}
//                 required
//                 error={!!errors.confirm_password}
//                 helperText={errors.confirm_password}
//               />
//             </Grid>
//             <Grid item xs={12} md={4}>
//               <StyledTextField
//                 fullWidth
//                 label="Date of Birth"
//                 name="date_of_birth"
//                 type="date"
//                 InputLabelProps={{ shrink: true }}
//                 value={formData.date_of_birth}
//                 onChange={handleChange}
//                 required
//               />
//             </Grid>
//             <Grid item xs={12} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel id="gender-label">Gender</InputLabel>
//                 <Select
//                   labelId="gender-label"
//                   name="gender"
//                   value={formData.gender}
//                   onChange={handleChange}
//                   required
//                 >
//                   <MenuItem value="Male">Male</MenuItem>
//                   <MenuItem value="Female">Female</MenuItem>
//                   <MenuItem value="Other">Other</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel id="communication-label">Preferred Communication</InputLabel>
//                 <Select
//                   labelId="communication-label"
//                   name="communication_preference"
//                   value={formData.communication_preference}
//                   onChange={handleChange}
//                 >
//                   <MenuItem value="Email">Email</MenuItem>
//                   <MenuItem value="Phone">Phone</MenuItem>
//                   <MenuItem value="SMS">SMS</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12}>
//               <FormControlLabel
//                 control={<Checkbox name="consent" checked={formData.consent} onChange={handleChange} />}
//                 label="I agree to the terms and conditions"
//               />
//             </Grid>
//             <Grid item xs={4} >
//               <RegisterButton type="submit" fullWidth disabled={loading}>
//                 {loading ? <CircularProgress size={24} /> : 'Register'}
//               </RegisterButton>
//             </Grid>
//           </Grid>
//         </form>
//       </StyledPaper>
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}>
//         <Alert
//           onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//           severity={snackbar.severity}
//           sx={{ width: '100%' }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// }

// import React, { useState } from 'react';
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   IconButton,
//   InputAdornment,
//   Paper,
//   Snackbar,
//   Alert,
//   CircularProgress,
//   Grid,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Checkbox,
//   FormControlLabel,
// } from '@mui/material';
// import { Visibility, VisibilityOff } from '@mui/icons-material';
// import { styled } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import Logo1 from '../../src/landpageimage/logo1.png';
// import Logo2 from '../../src/landpageimage/TDTLLogo.png';
// import Logo3 from '../../src/landpageimage/logo2.jpg';
// import Logo4 from '../../src/landpageimage/logo1.png';

// const themeColors = {
//   primary: '#00A76F',
//   gradient: 'linear-gradient(135deg, #00A76F 0%, #2196F3 100%)',
//   background: 'radial-gradient(217.23% 100.08% at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, #6633EE 69.34%,rgb(15, 19, 26) 100%)',
//   padding: '16px',
// };

// const StyledPaper = styled(Paper)(() => ({
//   display: 'flex',
//   flexDirection: 'column',
//   alignItems: 'center',
//   width: '90%',
//   maxWidth: '1200px',
//   margin: '0 auto',
//   borderRadius: '24px',
//   padding: '16px',
//   backgroundColor: '#FFFFFF',
//   boxShadow: '0 20px 40px rgba(0, 167, 111, 0.15)',
// }));

// const LogoContainer = styled(Box)(() => ({
//   display: 'grid',
//   gridTemplateColumns: 'repeat(4, 1fr)',
//   gap: '16px',
//   justifyContent: 'center',
//   alignItems: 'center',
//   width: '100%',
//   padding: '16px 0',
//   marginBottom: '16px',
//   '@media (max-width: 600px)': {
//     gridTemplateColumns: 'repeat(2, 1fr)',
//   },
// }));

// const LogoImage = styled('img')(() => ({
//   maxWidth: '100px',
//   maxHeight: '80px',
//   objectFit: 'contain',
//   margin: '0 auto',
// }));

// const StyledTextField = styled(TextField)(() => ({
//   '& .MuiOutlinedInput-root': {
//     borderRadius: '12px',
//     backgroundColor: '#F3F4F6',
//     '&:hover': {
//       backgroundColor: '#F9FAFB',
//     },
//     '&.Mui-focused fieldset': {
//       borderColor: themeColors.primary,
//     },
//   },
//   '& .MuiInputBase-input': {
//     fontSize: '0.875rem',
//   },
//   '& .MuiFormLabel-root': {
//     fontSize: '0.875rem',
//   },
// }));

// const RegisterButton = styled(Button)(() => ({
//   backgroundColor: themeColors.primary,
//   color: 'white',
//   padding: '8px',
//   borderRadius: '16px',
//   fontWeight: 600,
//   '&:hover': {
//     backgroundColor: '#008F5D',
//   },
// }));

// export default function StudentRegister() {
//   const navigate = useNavigate();
//   const [showPassword, setShowPassword] = useState(false);
//   const [formData, setFormData] = useState({
//     full_name: '',
//     email: '',
//     password: '',
//     confirm_password: '',
//     phone_number: '',
//     address: '',
//     city: '',
//     state: '',
//     postal_code: '',
//     country: '',
//     date_of_birth: '',
//     gender: '',
//     institution: '',
//     field_of_study: '',
//     graduation_year: '',
//     role: 'Student',
//     communication_preference: 'Email',
//     consent: false,
//   });
//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//   const validate = () => {
//     const newErrors = {};
//     if (!/^[a-zA-Z ]+$/.test(formData.full_name)) {
//       newErrors.full_name = 'Full Name should contain only letters and spaces';
//     }
//     if (!/^[0-9]{10}$/.test(formData.phone_number)) {
//       newErrors.phone_number = 'Phone Number should be exactly 10 digits';
//     }
//     if (!/^[0-9]{6}$/.test(formData.postal_code)) {
//       newErrors.postal_code = 'Postal Code should be exactly 6 digits';
//     }
//     if (!/^[0-9]+$/.test(formData.graduation_year)) {
//       newErrors.graduation_year = 'Graduation Year should only contain numbers';
//     }
//     if (formData.password !== formData.confirm_password) {
//       newErrors.confirm_password = 'Passwords do not match';
//     }
//     if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
//       newErrors.email = 'Invalid email address';
//     }
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: type === 'checkbox' ? checked : value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;
//     setLoading(true);
//     try {
//       const response = await fetch('http://65.0.71.177:8000/api/register_stud/', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(formData),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         setSnackbar({ open: true, message: 'Registration successful!', severity: 'success' });
//         setTimeout(() => navigate('/Login'), 2000);
//       } else {
//         setSnackbar({ open: true, message: data.msg || 'Registration failed!', severity: 'error' });
//       }
//     } catch (error) {
//       setSnackbar({ open: true, message: 'An error occurred. Please try again.', severity: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         background: themeColors.background,
//         padding: '16px',
//       }}
//     >
//       <StyledPaper>
//         <LogoContainer>
//           <LogoImage src={Logo1} alt="Logo 1" />
//           <LogoImage src={Logo2} alt="Logo 2" />
//           <LogoImage src={Logo3} alt="Logo 3" />
//           <LogoImage src={Logo4} alt="Logo 4" />
//         </LogoContainer>

//         <Typography
//   variant="h5"
//   fontWeight="bold"
//   mb={3}
//   sx={{
//     color: 'transparent',
//     backgroundImage: themeColors.gradient,
//     backgroundClip: 'text',
//     WebkitBackgroundClip: 'text',
//     textAlign: 'center',
//     fontSize: '1.5rem',
//     transition: 'transform 0.3s ease, opacity 0.3s ease',
//     animation: 'pulse 2s infinite',
//     cursor: 'pointer',
//     '@keyframes pulse': {
//       '0%': { transform: 'scale(1)', opacity: 1 },
//       '50%': { transform: 'scale(1.05)', opacity: 0.9 },
//       '100%': { transform: 'scale(1)', opacity: 1 },
//     },
//     '&:hover': {
//       transform: 'scale(1.1)',
//       opacity: 1,
//     },
//   }}
// >
//   "Empower Your Journey – Register Today to Become a Future Entrepreneur!"
// </Typography>

//         <form onSubmit={handleSubmit} style={{ width: '100%' }}>
//           <Grid container spacing={1}>
//             {Object.entries({
//               full_name: 'Full Name',
//               email: 'Email',
//               phone_number: 'Phone Number',
//               address: 'Address',
//               city: 'City',
//               state: 'State',
//               postal_code: 'Postal Code',
//               country: 'Country',
//               institution: 'Institution',
//               field_of_study: 'Field of Study',
//               graduation_year: 'Graduation Year',
//             }).map(([name, label]) => (
//               <Grid item xs={12} sm={6} md={4} key={name}>
//                 <StyledTextField
//                   fullWidth
//                   label={label}
//                   name={name}
//                   type={name === 'graduation_year' || name === 'postal_code' ? 'number' : 'text'}
//                   value={formData[name]}
//                   onChange={handleChange}
//                   required
//                   error={!!errors[name]}
//                   helperText={errors[name]}
//                 />
//               </Grid>
//             ))}
//             <Grid item xs={12} sm={6} md={4}>
//               <StyledTextField
//                 fullWidth
//                 label="Password"
//                 name="password"
//                 type={showPassword ? 'text' : 'password'}
//                 value={formData.password}
//                 onChange={handleChange}
//                 required
//                 error={!!errors.password}
//                 helperText={errors.password}
//                 InputProps={{
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton onClick={() => setShowPassword(!showPassword)}>
//                         {showPassword ? <VisibilityOff /> : <Visibility />}
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6} md={4}>
//               <StyledTextField
//                 fullWidth
//                 label="Confirm Password"
//                 name="confirm_password"
//                 type="password"
//                 value={formData.confirm_password}
//                 onChange={handleChange}
//                 required
//                 error={!!errors.confirm_password}
//                 helperText={errors.confirm_password}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6} md={4}>
//               <StyledTextField
//                 fullWidth
//                 label="Date of Birth"
//                 name="date_of_birth"
//                 type="date"
//                 InputLabelProps={{ shrink: true }}
//                 value={formData.date_of_birth}
//                 onChange={handleChange}
//                 required
//               />
//             </Grid>
//             <Grid item xs={12} sm={6} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel id="gender-label">Gender</InputLabel>
//                 <Select
//                   labelId="gender-label"
//                   name="gender"
//                   value={formData.gender}
//                   onChange={handleChange}
//                   required
//                 >
//                   <MenuItem value="Male">Male</MenuItem>
//                   <MenuItem value="Female">Female</MenuItem>
//                   <MenuItem value="Other">Other</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} sm={6} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel id="communication-label">Preferred Communication</InputLabel>
//                 <Select
//                   labelId="communication-label"
//                   name="communication_preference"
//                   value={formData.communication_preference}
//                   onChange={handleChange}
//                 >
//                   <MenuItem value="Email">Email</MenuItem>
//                   <MenuItem value="Phone">Phone</MenuItem>
//                   <MenuItem value="SMS">SMS</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12}>
//               <FormControlLabel
//                 control={<Checkbox name="consent" checked={formData.consent} onChange={handleChange} />}
//                 label="I agree to the terms and conditions"
//               />
//             </Grid>
//             <Grid item xs={12}>
//               <RegisterButton type="submit" fullWidth disabled={loading}>
//                 {loading ? <CircularProgress size={24} /> : 'Register'}
//               </RegisterButton>
//             </Grid>
//           </Grid>
//         </form>
//       </StyledPaper>
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//       >
//         <Alert
//           onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//           severity={snackbar.severity}
//           sx={{ width: '100%' }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// }

// import React, { useState } from 'react';
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   IconButton,
//   InputAdornment,
//   Paper,
//   Snackbar,
//   Alert,
//   CircularProgress,
//   Grid,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Checkbox,
//   FormControlLabel,
// } from '@mui/material';
// import { Visibility, VisibilityOff } from '@mui/icons-material';
// import { styled } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import Logo1 from '../../src/landpageimage/logo1.png';
// import Logo2 from '../../src/landpageimage/TDTLLogo.png';
// import Logo3 from '../../src/landpageimage/logo2.jpg';
// import Logo4 from '../../src/landpageimage/logo1.png';

// const themeColors = {
//   primary: '#00A76F',
//   gradient: 'linear-gradient(135deg, #00A76F 0%, #2196F3 100%)',
//   background: 'radial-gradient(217.23% 100.08% at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, #6633EE 69.34%, rgb(15, 19, 26) 100%)',
// };

// const StyledPaper = styled(Paper)(() => ({
//   display: 'flex',
//   flexDirection: 'column',
//   alignItems: 'center',
//   width: '90%',
//   maxWidth: '1200px',
//   margin: '0 auto',
//   borderRadius: '24px',
//   padding: '16px',
//   backgroundColor: '#FFFFFF',
//   boxShadow: '0 20px 40px rgba(0, 167, 111, 0.15)',
// }));

// const LogoContainer = styled(Box)(() => ({
//   display: 'grid',
//   gridTemplateColumns: 'repeat(4, 1fr)',
//   gap: '16px',
//   justifyContent: 'center',
//   alignItems: 'center',
//   width: '100%',
//   padding: '16px 0',
//   marginBottom: '16px',
//   '@media (max-width: 600px)': {
//     gridTemplateColumns: 'repeat(2, 1fr)',
//   },
// }));

// const LogoImage = styled('img')(() => ({
//   maxWidth: '100px',
//   maxHeight: '80px',
//   objectFit: 'contain',
//   margin: '0 auto',
// }));

// const StyledTextField = styled(TextField)(() => ({
//   '& .MuiOutlinedInput-root': {
//     borderRadius: '12px',
//     backgroundColor: '#F3F4F6',
//     '&:hover': {
//       backgroundColor: '#F9FAFB',
//     },
//     '&.Mui-focused fieldset': {
//       borderColor: themeColors.primary,
//     },
//   },
// }));

// const RegisterButton = styled(Button)(() => ({
//   backgroundColor: themeColors.primary,
//   color: 'white',
//   padding: '8px',
//   borderRadius: '16px',
//   fontWeight: 600,
//   '&:hover': {
//     backgroundColor: '#008F5D',
//   },
// }));

// export default function StudentRegister() {
//   const navigate = useNavigate();
//   const [showPassword, setShowPassword] = useState(false);
//   const [formData, setFormData] = useState({
//     full_name: '',
//     email: '',
//     password: '',
//     phone_number: '',
//     role: 'Student',
//     institution: '',
//     address: '',
//     postal_code: '',
//     country: '',
//     city: '',
//     state: '',
//     gender: '',
//     field_of_study: '',
//     graduation_year: '',
//   });
//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//   const validate = () => {
//     const newErrors = {};
//     if (!/^[a-zA-Z ]+$/.test(formData.full_name)) {
//       newErrors.full_name = 'Full Name should contain only letters and spaces';
//     }
//     if (!/^[0-9]{10}$/.test(formData.phone_number)) {
//       newErrors.phone_number = 'Phone Number should be exactly 10 digits';
//     }
//     if (!/^[0-9]{6}$/.test(formData.postal_code)) {
//       newErrors.postal_code = 'Postal Code should be exactly 6 digits';
//     }
//     if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
//       newErrors.email = 'Invalid email address';
//     }
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;
//     setLoading(true);
//     try {
//       const response = await fetch('http://65.0.71.177:8000/api/register_stud/', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(formData),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         setSnackbar({ open: true, message: 'Registration successful!', severity: 'success' });
//         setTimeout(() => navigate('/Login'), 2000);
//       } else {
//         setSnackbar({ open: true, message: data.msg || 'Registration failed!', severity: 'error' });
//       }
//     } catch (error) {
//       setSnackbar({ open: true, message: 'An error occurred. Please try again.', severity: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         background: themeColors.background,
//         padding: '16px',
//       }}
//     >
//       <StyledPaper>
//         <LogoContainer>
//           <LogoImage src={Logo1} alt="Logo 1" />
//           <LogoImage src={Logo2} alt="Logo 2" />
//           <LogoImage src={Logo3} alt="Logo 3" />
//           <LogoImage src={Logo4} alt="Logo 4" />
//         </LogoContainer>

//         <Typography
//           variant="h5"
//           fontWeight="bold"
//           mb={3}
//           sx={{
//             color: 'transparent',
//             backgroundImage: themeColors.gradient,
//             backgroundClip: 'text',
//             WebkitBackgroundClip: 'text',
//             textAlign: 'center',
//             fontSize: '1.5rem',
//           }}
//         >
//           "Empower Your Journey – Register Today to Become a Future Entrepreneur!"
//         </Typography>

//         <form onSubmit={handleSubmit} style={{ width: '100%' }}>
//           <Grid container spacing={2}>
//             {Object.entries({
//               full_name: 'Full Name',
//               email: 'Email',
//               phone_number: 'Phone Number',
//               address: 'Address',
//               city: 'City',
//               state: 'State',
//               postal_code: 'Postal Code',
//               country: 'Country',
//               institution: 'Institution',
//               field_of_study: 'Field of Study',
//               graduation_year: 'Graduation Year',
//             }).map(([name, label]) => (
//               <Grid item xs={12} sm={6} key={name}>
//                 <StyledTextField
//                   fullWidth
//                   label={label}
//                   name={name}
//                   type={name === 'graduation_year' || name === 'postal_code' ? 'number' : 'text'}
//                   value={formData[name]}
//                   onChange={handleChange}
//                   required
//                   error={!!errors[name]}
//                   helperText={errors[name]}
//                 />
//               </Grid>
//             ))}
//             <Grid item xs={12} sm={6}>
//               <FormControl fullWidth>
//                 <InputLabel>Gender</InputLabel>
//                 <Select
//                   name="gender"
//                   value={formData.gender}
//                   onChange={handleChange}
//                   required
//                 >
//                   <MenuItem value="M">Male</MenuItem>
//                   <MenuItem value="F">Female</MenuItem>
//                   <MenuItem value="O">Other</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12}>
//               <RegisterButton type="submit" fullWidth disabled={loading}>
//                 {loading ? <CircularProgress size={24} /> : 'Register'}
//               </RegisterButton>
//             </Grid>
//           </Grid>
//         </form>
//       </StyledPaper>
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//       >
//         <Alert
//           onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//           severity={snackbar.severity}
//           sx={{ width: '100%' }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// }

// import React, { useState } from 'react';
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   IconButton,
//   InputAdornment,
//   Paper,
//   Snackbar,
//   Alert,
//   CircularProgress,
//   Grid,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Checkbox,
//   FormControlLabel,
// } from '@mui/material';
// import { Visibility, VisibilityOff } from '@mui/icons-material';
// import { styled } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import Logo1 from '../../src/landpageimage/logo1.png';
// import Logo2 from '../../src/landpageimage/TDTLLogo.png';
// import Logo3 from '../../src/landpageimage/logo2.jpg';
// import Logo4 from '../../src/landpageimage/logo1.png';

// const themeColors = {
//   primary: '#00A76F',
//   gradient: 'linear-gradient(135deg, #00A76F 0%, #2196F3 100%)',
//   background: 'radial-gradient(217.23% 100.08% at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, #6633EE 69.34%, rgb(15, 19, 26) 100%)',
// };

// const StyledPaper = styled(Paper)(() => ({
//   display: 'flex',
//   flexDirection: 'column',
//   alignItems: 'center',
//   width: '90%',
//   maxWidth: '1200px',
//   margin: '0 auto',
//   borderRadius: '24px',
//   padding: '16px',
//   backgroundColor: '#FFFFFF',
//   boxShadow: '0 20px 40px rgba(0, 167, 111, 0.15)',
// }));

// const LogoContainer = styled(Box)(() => ({
//   display: 'grid',
//   gridTemplateColumns: 'repeat(4, 1fr)',
//   gap: '16px',
//   justifyContent: 'center',
//   alignItems: 'center',
//   width: '100%',
//   padding: '16px 0',
//   marginBottom: '16px',
//   '@media (max-width: 600px)': {
//     gridTemplateColumns: 'repeat(2, 1fr)',
//   },
// }));

// const LogoImage = styled('img')(() => ({
//   maxWidth: '100px',
//   maxHeight: '80px',
//   objectFit: 'contain',
//   margin: '0 auto',
// }));

// const StyledTextField = styled(TextField)(() => ({
//   '& .MuiOutlinedInput-root': {
//     borderRadius: '12px',
//     backgroundColor: '#F3F4F6',
//     '&:hover': {
//       backgroundColor: '#F9FAFB',
//     },
//     '&.Mui-focused fieldset': {
//       borderColor: themeColors.primary,
//     },
//   },
// }));

// const RegisterButton = styled(Button)(() => ({
//   backgroundColor: themeColors.primary,
//   color: 'white',
//   padding: '8px',
//   borderRadius: '16px',
//   fontWeight: 600,
//   '&:hover': {
//     backgroundColor: '#008F5D',
//   },
// }));

// export default function StudentRegister() {
//   const navigate = useNavigate();
//   const [showPassword, setShowPassword] = useState(false);
//   const [formData, setFormData] = useState({
//     full_name: '',
//     email: '',
//     password: '',
//     confirm_password: '',
//     phone_number: '',
//     role: 'Student',
//     institution: '',
//     address: '',
//     postal_code: '',
//     country: '',
//     city: '',
//     state: '',
//     gender: '',
//     field_of_study: '',
//     graduation_year: '',
//   });
//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//   const validate = () => {
//     const newErrors = {};
//     if (!/^[a-zA-Z ]+$/.test(formData.full_name)) {
//       newErrors.full_name = 'Full Name should contain only letters and spaces';
//     }
//     if (!/^[0-9]{10}$/.test(formData.phone_number)) {
//       newErrors.phone_number = 'Phone Number should be exactly 10 digits';
//     }
//     if (!/^[0-9]{6}$/.test(formData.postal_code)) {
//       newErrors.postal_code = 'Postal Code should be exactly 6 digits';
//     }
//     if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
//       newErrors.email = 'Invalid email address';
//     }
//     if (!formData.password) {
//       newErrors.password = 'Password is required';
//     } else if (formData.password.length < 8) {
//       newErrors.password = 'Password must be at least 8 characters';
//     }
//     if (formData.password !== formData.confirm_password) {
//       newErrors.confirm_password = 'Passwords do not match';
//     }
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;
//     setLoading(true);
//     try {
//       const response = await fetch('https://newbackend.elephant-tank.com/api/register_stud/', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(formData),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         setSnackbar({ open: true, message: 'Registration successful!', severity: 'success' });
//         setTimeout(() => navigate('/Login'), 2000);
//       } else {
//         setSnackbar({ open: true, message: data.msg || 'Registration failed!', severity: 'error' });
//       }
//     } catch (error) {
//       setSnackbar({ open: true, message: 'An error occurred. Please try again.', severity: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         background: themeColors.background,
//         padding: '16px',
//       }}
//     >
//       <StyledPaper>
//         <LogoContainer>
//           <LogoImage src={Logo1} alt="Logo 1" />
//           <LogoImage src={Logo2} alt="Logo 2" />
//           <LogoImage src={Logo3} alt="Logo 3" />
//           <LogoImage src={Logo4} alt="Logo 4" />
//         </LogoContainer>

//         <Typography
//           variant="h5"
//           fontWeight="bold"
//           mb={3}
//           sx={{
//             color: 'transparent',
//             backgroundImage: themeColors.gradient,
//             backgroundClip: 'text',
//             WebkitBackgroundClip: 'text',
//             textAlign: 'center',
//             fontSize: '1.5rem',
//           }}
//         >
//           "Empower Your Journey – Register Today to Become a Future Entrepreneur!"
//         </Typography>

//         <form onSubmit={handleSubmit} style={{ width: '100%' }}>
//           <Grid container spacing={2}>
//             {Object.entries({
//               full_name: 'Full Name',
//               email: 'Email',
//               phone_number: 'Phone Number',
//               address: 'Address',
//               city: 'City',
//               state: 'State',
//               postal_code: 'Postal Code',
//               country: 'Country',
//               institution: 'Institution',
//               field_of_study: 'Field of Study',
//               graduation_year: 'Graduation Year',
//             }).map(([name, label]) => (
//               <Grid item xs={12} sm={6} key={name}>
//                 <StyledTextField
//                   fullWidth
//                   label={label}
//                   name={name}
//                   type={name === 'graduation_year' || name === 'postal_code' ? 'number' : 'text'}
//                   value={formData[name]}
//                   onChange={handleChange}
//                   required
//                   error={!!errors[name]}
//                   helperText={errors[name]}
//                 />
//               </Grid>
//             ))}
//             <Grid item xs={12} sm={6}>
//               <StyledTextField
//                 fullWidth
//                 label="Password"
//                 name="password"
//                 type={showPassword ? 'text' : 'password'}
//                 value={formData.password}
//                 onChange={handleChange}
//                 required
//                 error={!!errors.password}
//                 helperText={errors.password}
//                 InputProps={{
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton onClick={() => setShowPassword(!showPassword)}>
//                         {showPassword ? <VisibilityOff /> : <Visibility />}
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <StyledTextField
//                 fullWidth
//                 label="Confirm Password"
//                 name="confirm_password"
//                 type="password"
//                 value={formData.confirm_password}
//                 onChange={handleChange}
//                 required
//                 error={!!errors.confirm_password}
//                 helperText={errors.confirm_password}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <FormControl fullWidth>
//                 <InputLabel>Gender</InputLabel>
//                 <Select
//                   name="gender"
//                   value={formData.gender}
//                   onChange={handleChange}
//                   required
//                 >
//                   <MenuItem value="M">Male</MenuItem>
//                   <MenuItem value="F">Female</MenuItem>
//                   <MenuItem value="O">Other</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12}>
//               <RegisterButton type="submit" fullWidth disabled={loading}>
//                 {loading ? <CircularProgress size={24} /> : 'Register'}
//               </RegisterButton>
//             </Grid>
//           </Grid>
//         </form>
//       </StyledPaper>
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//       >
//         <Alert
//           onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//           severity={snackbar.severity}
//           sx={{ width: '100%' }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// }

// import React, { useState } from 'react';
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   IconButton,
//   InputAdornment,
//   Paper,
//   Snackbar,
//   Alert,
//   CircularProgress,
//   Grid,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
// } from '@mui/material';
// import { Visibility, VisibilityOff } from '@mui/icons-material';
// import { styled } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import Logo1 from '../../src/landpageimage/logo1.png';
// import Logo2 from '../../src/landpageimage/TDTLLogo.png';
// import Logo3 from '../../src/landpageimage/logo2.jpg';
// import Logo4 from '../../src/landpageimage/logo1.png';

// // const themeColors = {
// //   primary: '#00A76F',
// //   gradient: 'linear-gradient(135deg, #00A76F 0%, #2196F3 100%)',
// //   background: 'radial-gradient(217.23% 100.08% at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, #6633EE 69.34%, rgb(15, 19, 26) 100%)',
// // };
// const themeColors = {
//   primary: '#2196F3', // Blue
//   gradient: 'linear-gradient(135deg, #2196F3 0%, #6633EE 100%)',
//   background: 'radial-gradient(217.23% 100.08% at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, #6633EE 69.34%, rgb(15, 19, 26) 100%)',
// };

// const StyledPaper = styled(Paper)(() => ({
//   display: 'flex',
//   flexDirection: 'column',
//   alignItems: 'center',
//   width: '90%',
//   maxWidth: '1200px',
//   margin: '0 auto',
//   borderRadius: '24px',
//   padding: '16px',
//   backgroundColor: '#FFFFFF',
//   boxShadow: '0 20px 40px rgba(0, 167, 111, 0.15)',
// }));

// const LogoContainer = styled(Box)(() => ({
//   display: 'grid',
//   gridTemplateColumns: 'repeat(4, 1fr)',
//   gap: '16px',
//   justifyContent: 'center',
//   alignItems: 'center',
//   width: '100%',
//   padding: '16px 0',
//   marginBottom: '16px',
//   '@media (max-width: 600px)': {
//     gridTemplateColumns: 'repeat(2, 1fr)',
//   },
// }));

// const LogoImage = styled('img')(() => ({
//   maxWidth: '100px',
//   maxHeight: '80px',
//   objectFit: 'contain',
//   margin: '0 auto',
// }));

// const StyledTextField = styled(TextField)(() => ({
//   '& .MuiOutlinedInput-root': {
//     borderRadius: '12px',
//     backgroundColor: '#F3F4F6',
//     '&:hover': {
//       backgroundColor: '#F9FAFB',
//     },
//     '&.Mui-focused fieldset': {
//       borderColor: themeColors.primary,
//     },
//   },
// }));

// const RegisterButton = styled(Button)(() => ({
//   background: themeColors.gradient,
//   color: 'white',
//   padding: '8px',
//   borderRadius: '16px',
//   fontWeight: 600,
//   '&:hover': {
//     background: '#1E88E5', // A darker shade of blue
//   },
// }));

// export default function StudentRegister() {
//   const navigate = useNavigate();
//   const [showPassword, setShowPassword] = useState(false);
//   const [formData, setFormData] = useState({
//     full_name: '',
//     email: '',
//     password: '',
//     confirm_password: '',
//     phone_number: '',
//     role: 'Student',
//     institution: '',
//     address: '',
//     postal_code: '',
//     country: '',
//     city: '',
//     state: '',
//     gender: '',
//     field_of_study: '',
//     graduation_year: '',
//   });
//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//   const validate = () => {
//     const newErrors = {};
//     if (!/^[a-zA-Z ]+$/.test(formData.full_name)) {
//       newErrors.full_name = 'Full Name should contain only letters and spaces';
//     }
//     if (!/^[0-9]{10}$/.test(formData.phone_number)) {
//       newErrors.phone_number = 'Phone Number should be exactly 10 digits';
//     }
//     if (!/^[0-9]{6}$/.test(formData.postal_code)) {
//       newErrors.postal_code = 'Postal Code should be exactly 6 digits';
//     }
//     if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
//       newErrors.email = 'Invalid email address';
//     }
//     if (!formData.password) {
//       newErrors.password = 'Password is required';
//     } else if (formData.password.length < 8) {
//       newErrors.password = 'Password must be at least 8 characters';
//     }
//     if (formData.password !== formData.confirm_password) {
//       newErrors.confirm_password = 'Passwords do not match';
//     }
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;
//     setLoading(true);
//     try {
//       const response = await fetch('https://newbackend.elephant-tank.com/api/register_stud/', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(formData),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         setSnackbar({ open: true, message: 'Verify OTP for Confirmation of Registration', severity: 'success' });
//         setTimeout(() => navigate('/Otpverification'), 2000);
//       } else {
//         setSnackbar({ open: true, message: data.msg || 'Registration failed!', severity: 'error' });
//       }
//     } catch (error) {
//       setSnackbar({ open: true, message: 'An error occurred. Please try again.', severity: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         background: themeColors.background,
//         padding: '16px',
//       }}
//     >
//       <StyledPaper>
//         <LogoContainer>
//           <LogoImage src={Logo1} alt="Logo 1" />
//           <LogoImage src={Logo2} alt="Logo 2" />
//           <LogoImage src={Logo3} alt="Logo 3" />
//           <LogoImage src={Logo4} alt="Logo 4" />
//         </LogoContainer>
//         <Typography
//   variant="h5"
//   fontWeight="bold"
//   mb={3}
//   sx={{
//     color: 'transparent',
//     backgroundImage: themeColors.gradient,
//     backgroundClip: 'text',
//     WebkitBackgroundClip: 'text',
//     textAlign: 'center',
//     fontSize: '1.5rem',
//     animation: 'pulse 2s infinite', // Animation added
//     '@keyframes pulse': {
//       '0%': {
//         transform: 'scale(1)',
//         opacity: 1,
//       },
//       '50%': {
//         transform: 'scale(1.05)',
//         opacity: 0.9,
//       },
//       '100%': {
//         transform: 'scale(1)',
//         opacity: 1,
//       },
//     },
//   }}
// >
//   "Empower Your Journey – Register Today to Become a Future Entrepreneur!"
// </Typography>

//         {/* <Typography
//           variant="h5"
//           fontWeight="bold"
//           mb={3}
//           sx={{
//             color: 'transparent',
//             backgroundImage: themeColors.gradient,
//             backgroundClip: 'text',
//             WebkitBackgroundClip: 'text',
//             textAlign: 'center',
//             fontSize: '1.5rem',
//           }}
//         >
//           "Empower Your Journey – Register Today to Become a Future Entrepreneur!"
//         </Typography> */}

//         <form onSubmit={handleSubmit} style={{ width: '100%' }}>
//           <Grid container spacing={2}>
//             {Object.entries({
//               full_name: 'Full Name',
//               email: 'Email',
//               phone_number: 'Phone Number',
//               address: 'Address',
//               city: 'City',
//               state: 'State',
//               postal_code: 'Postal Code',
//               country: 'Country',
//               institution: 'Institution',
//               field_of_study: 'Field of Study',
//               graduation_year: 'Graduation Year',
//             }).map(([name, label]) => (
//               <Grid item xs={12} sm={4} key={name}>
//                 <StyledTextField
//                   fullWidth
//                   label={label}
//                   name={name}
//                   type={name === 'graduation_year' || name === 'postal_code' ? 'number' : 'text'}
//                   value={formData[name]}
//                   onChange={handleChange}
//                   required
//                   error={!!errors[name]}
//                   helperText={errors[name]}
//                 />
//               </Grid>
//             ))}
//             <Grid item xs={12} sm={4}>
//               <StyledTextField
//                 fullWidth
//                 label="Password"
//                 name="password"
//                 type={showPassword ? 'text' : 'password'}
//                 value={formData.password}
//                 onChange={handleChange}
//                 required
//                 error={!!errors.password}
//                 helperText={errors.password}
//                 InputProps={{
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton onClick={() => setShowPassword(!showPassword)}>
//                         {showPassword ? <VisibilityOff /> : <Visibility />}
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//               />
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <StyledTextField
//                 fullWidth
//                 label="Confirm Password"
//                 name="confirm_password"
//                 type="password"
//                 value={formData.confirm_password}
//                 onChange={handleChange}
//                 required
//                 error={!!errors.confirm_password}
//                 helperText={errors.confirm_password}
//               />
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Gender</InputLabel>
//                 <Select
//                   name="gender"
//                   value={formData.gender}
//                   onChange={handleChange}
//                   required
//                 >
//                   <MenuItem value="M">Male</MenuItem>
//                   <MenuItem value="F">Female</MenuItem>
//                   <MenuItem value="O">Other</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12}>
//               <RegisterButton type="submit" fullWidth disabled={loading}>
//                 {loading ? <CircularProgress size={24} /> : 'Register'}
//               </RegisterButton>
//             </Grid>
//           </Grid>
//         </form>
//       </StyledPaper>
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}>
//         <Alert
//           onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))} 
//           severity={snackbar.severity} 
//           sx={{ width: '100%' }}>
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// }


// import React, { useState } from 'react';
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   IconButton,
//   InputAdornment,
//   Paper,
//   Snackbar,
//   Alert,
//   CircularProgress,
//   Grid,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
// } from '@mui/material';
// import { Visibility, VisibilityOff } from '@mui/icons-material';
// import { styled } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import Logo1 from '../../src/landpageimage/logo1.png';
// import Logo2 from '../../src/landpageimage/TDTLLogo.png';
// import Logo3 from '../../src/landpageimage/logo2.jpg';
// import Logo4 from '../landpageimage1/DYPLogo.png';
// import OtpImage from '../landpageimage/logo1.png'; // Replace with your image path
// import Swal from 'sweetalert2';

// const themeColors = {
//   primary: '#2196F3',
//   gradient: 'linear-gradient(135deg, #2196F3 0%, #6633EE 100%)',
//   background: 'radial-gradient(217.23% 100.08% at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, #6633EE 69.34%, rgb(15, 19, 26) 100%)',
// };

// const StyledPaper = styled(Paper)(() => ({
//   display: 'flex',
//   flexDirection: 'column',
//   alignItems: 'center',
//   width: '90%',
//   maxWidth: '1200px',
//   margin: '0 auto',
//   borderRadius: '24px',
//   padding: '16px',
//   backgroundColor: '#FFFFFF',
//   boxShadow: '0 20px 40px rgba(0, 167, 111, 0.15)',
// }));

// const LogoContainer = styled(Box)(() => ({
//   display: 'grid',
//   gridTemplateColumns: 'repeat(4, 1fr)',
//   gap: '16px',
//   justifyContent: 'center',
//   alignItems: 'center',
//   width: '100%',
//   padding: '16px 0',
//   marginBottom: '16px',
//   '@media (max-width: 600px)': {
//     gridTemplateColumns: 'repeat(2, 1fr)',
//   },
// }));

// const LogoImage = styled('img')(() => ({
//   maxWidth: '100px',
//   maxHeight: '80px',
//   objectFit: 'contain',
//   margin: '0 auto',
// }));

// const StyledTextField = styled(TextField)(() => ({
//   '& .MuiOutlinedInput-root': {
//     borderRadius: '12px',
//     backgroundColor: '#F3F4F6',
//     '&:hover': {
//       backgroundColor: '#F9FAFB',
//     },
//     '&.Mui-focused fieldset': {
//       borderColor: themeColors.primary,
//     },
//   },
// }));

// const RegisterButton = styled(Button)(() => ({
//   background: themeColors.gradient,
//   color: 'white',
//   padding: '8px',
//   borderRadius: '16px',
//   fontWeight: 600,
//   '&:hover': {
//     background: '#1E88E5',
//   },
// }));

// export default function StudentRegister() {
//   const navigate = useNavigate();
//   const [showPassword, setShowPassword] = useState(false);
//   const [formData, setFormData] = useState({
//     full_name: '',
//     email: '',
//     password: '',
//     confirm_password: '',
//     phone_number: '',
//     role: 'Student',
//     institution: '',
//     address: '',
//     postal_code: '',
//     country: '',
//     city: '',
//     state: '',
//     gender: '',
//     field_of_study: '',
//     graduation_year: '',
//   });
//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//   const validate = () => {
//     const newErrors = {};
//     if (!/^[a-zA-Z ]+$/.test(formData.full_name)) {
//       newErrors.full_name = 'Full Name should contain only letters and spaces';
//     }
//     if (!/^[0-9]{10}$/.test(formData.phone_number)) {
//       newErrors.phone_number = 'Phone Number should be exactly 10 digits';
//     }
//     if (!/^[0-9]{6}$/.test(formData.postal_code)) {
//       newErrors.postal_code = 'Postal Code should be exactly 6 digits';
//     }
//     if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
//       newErrors.email = 'Invalid email address';
//     }
//     if (!formData.password) {
//       newErrors.password = 'Password is required';
//     } else if (formData.password.length < 8) {
//       newErrors.password = 'Password must be at least 8 characters';
//     }
//     if (formData.password !== formData.confirm_password) {
//       newErrors.confirm_password = 'Passwords do not match';
//     }
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));
//   };

 
 

 

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;
//     setLoading(true);
//     try {
//       const response = await fetch('https://newbackend.elephant-tank.com/api/register_stud/', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(formData),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         Swal.fire({
//           title: 'Success!',
//           text: 'Verify OTP for Confirmation of Registration.',
//           icon: 'success',
//           timer: 2000,
//           showConfirmButton: false,
//           willClose: () => navigate('/Otpverification', { state: { email: formData.email } }),
//         });
//       } else {
//         Swal.fire({
//           title: 'Error!',
//           text: data.msg || 'Registration failed!',
//           icon: 'error',
//           confirmButtonText: 'Try Again',
//         });
//       }
//     } catch (error) {
//       Swal.fire({
//         title: 'Error!',
//         text: 'An error occurred. Please try again.',
//         icon: 'error',
//         confirmButtonText: 'Close',
//       });
//     } finally {
//       setLoading(false);
//     }
//   };
  
  
//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         background: themeColors.background,
//         padding: '16px',
//       }}
//     >
//       <StyledPaper>
//         <LogoContainer>
//           <LogoImage src={Logo1} alt="Logo 1" />
//           <LogoImage src={Logo2} alt="Logo 2" />
//           <LogoImage src={Logo3} alt="Logo 3" />
//           <LogoImage src={Logo4} alt="Logo 4" />
//         </LogoContainer>
//         <Typography
//           variant="h5"
//           fontWeight="bold"
//           mb={3}
//           sx={{
//             color: 'transparent',
//             backgroundImage: themeColors.gradient,
//             backgroundClip: 'text',
//             WebkitBackgroundClip: 'text',
//             textAlign: 'center',
//             fontSize: '1.5rem',
//           }}
//         >
//           Empower Your Journey – Register Today to Become a Future Entrepreneur!
//         </Typography>

//         <form onSubmit={handleSubmit} style={{ width: '100%' }}>
//           <Grid container spacing={2}>
//             {Object.entries({
//               full_name: 'Full Name',
//               email: 'Email',
//               phone_number: 'Phone Number',
//               address: 'Address',
//               city: 'City',
//               state: 'State',
//               postal_code: 'Postal Code',
//               country: 'Country',
//               institution: 'Institution',
//               field_of_study: 'Field of Study',
//               graduation_year: 'Graduation Year',
//             }).map(([name, label]) => (
//               <Grid item xs={12} sm={4} key={name}>
//                 <StyledTextField
//                   fullWidth
//                   label={label}
//                   name={name}
//                   type={name === 'graduation_year' || name === 'postal_code' ? 'number' : 'text'}
//                   value={formData[name]}
//                   onChange={handleChange}
//                   required
//                   error={!!errors[name]}
//                   helperText={errors[name]}
//                 />
//               </Grid>
//             ))}
//             <Grid item xs={12} sm={4}>
//               <StyledTextField
//                 fullWidth
//                 label="Password"
//                 name="password"
//                 type={showPassword ? 'text' : 'password'}
//                 value={formData.password}
//                 onChange={handleChange}
//                 required
//                 error={!!errors.password}
//                 helperText={errors.password}
//                 InputProps={{
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton onClick={() => setShowPassword(!showPassword)}>
//                         {showPassword ? <VisibilityOff /> : <Visibility />}
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//               />
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <StyledTextField
//                 fullWidth
//                 label="Confirm Password"
//                 name="confirm_password"
//                 type="password"
//                 value={formData.confirm_password}
//                 onChange={handleChange}
//                 required
//                 error={!!errors.confirm_password}
//                 helperText={errors.confirm_password}
//               />
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Gender</InputLabel>
//                 <Select
//                   name="gender"
//                   value={formData.gender}
//                   onChange={handleChange}
//                   required
//                 >
//                   <MenuItem value="M">Male</MenuItem>
//                   <MenuItem value="F">Female</MenuItem>
//                   <MenuItem value="O">Other</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12}>
//               <RegisterButton type="submit" fullWidth disabled={loading}>
//                 {loading ? <CircularProgress size={24} /> : 'Register'}
//               </RegisterButton>
//             </Grid>
//           </Grid>
//         </form>
//       </StyledPaper>
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//       >
//         <Alert
//           onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//           severity={snackbar.severity}
//           sx={{ width: '100%' }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// }
// export function OtpVerification() {
//   const navigate = useNavigate();
//   const [otp, setOtp] = useState(new Array(4).fill(''));
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
//   const email = "Annabell4@yahoo.com"; // Example email, replace with actual data
//   const role = "Student"; // Role value, replace if needed

//   const handleChange = (element, index) => {
//     if (/^\d$/.test(element.value) || element.value === '') {
//       const newOtp = [...otp];
//       newOtp[index] = element.value;
//       setOtp(newOtp);

//       if (element.value && index < 3) {
//         document.getElementById(`otp-input-${index + 1}`).focus();
//       }
//     }
//   };
// }

// import React, { useState } from 'react';
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   IconButton,
//   InputAdornment,
//   Paper,
//   Snackbar,
//   Alert,
//   CircularProgress,
//   Grid,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
// } from '@mui/material';
// import { Visibility, VisibilityOff } from '@mui/icons-material';
// import { styled } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import Logo1 from '../../src/landpageimage/logo1.png';
// import Logo2 from '../../src/landpageimage/TDTLLogo.png';
// import Logo3 from '../../src/landpageimage/logo2.jpg';
// import Logo4 from '../landpageimage1/DYPLogo.png';
// import OtpImage from '../landpageimage/logo1.png'; // Replace with your image path
// import Swal from 'sweetalert2';

// const themeColors = {
//   primary: '#2196F3',
//   gradient: 'linear-gradient(135deg, #2196F3 0%, #6633EE 100%)',
//   background: 'radial-gradient(217.23% 100.08% at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, #6633EE 69.34%, rgb(15, 19, 26) 100%)',
// };

// const StyledPaper = styled(Paper)(() => ({
//   display: 'flex',
//   flexDirection: 'column',
//   alignItems: 'center',
//   width: '90%',
//   maxWidth: '1200px',
//   margin: '0 auto',
//   borderRadius: '24px',
//   padding: '16px',
//   backgroundColor: '#FFFFFF',
//   boxShadow: '0 20px 40px rgba(0, 167, 111, 0.15)',
// }));

// const LogoContainer = styled(Box)(() => ({
//   display: 'grid',
//   gridTemplateColumns: 'repeat(4, 1fr)',
//   gap: '16px',
//   justifyContent: 'center',
//   alignItems: 'center',
//   width: '100%',
//   padding: '16px 0',
//   marginBottom: '16px',
//   '@media (max-width: 600px)': {
//     gridTemplateColumns: 'repeat(2, 1fr)',
//   },
// }));

// const LogoImage = styled('img')(() => ({
//   maxWidth: '100px',
//   maxHeight: '80px',
//   objectFit: 'contain',
//   margin: '0 auto',
// }));

// const StyledTextField = styled(TextField)(() => ({
//   '& .MuiOutlinedInput-root': {
//     borderRadius: '12px',
//     backgroundColor: '#F3F4F6',
//     '&:hover': {
//       backgroundColor: '#F9FAFB',
//     },
//     '&.Mui-focused fieldset': {
//       borderColor: themeColors.primary,
//     },
//   },
// }));

// const RegisterButton = styled(Button)(() => ({
//   background: themeColors.gradient,
//   color: 'white',
//   padding: '8px',
//   borderRadius: '16px',
//   fontWeight: 600,
//   '&:hover': {
//     background: '#1E88E5',
//   },
// }));

// export default function StudentRegister() {
//   const navigate = useNavigate();
//   const [showPassword, setShowPassword] = useState(false);
//   const [formData, setFormData] = useState({
//     full_name: '',
//     email: '',
//     password: '',
//     confirm_password: '',
//     phone_number: '',
//     role: 'Student',
//     institution: '',
//     address: '',
//     postal_code: '',
//     country: '',
//     city: '',
//     state: '',
//     gender: '',
//     field_of_study: '',
//     graduation_year: '',
//     linked_url: '',
//   });
//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//   const validate = () => {
//     const newErrors = {};
//     if (!/^[a-zA-Z ]+$/.test(formData.full_name)) {
//       newErrors.full_name = 'Full Name should contain only letters and spaces';
//     }
//     if (!/^[0-9]{10}$/.test(formData.phone_number)) {
//       newErrors.phone_number = 'Phone Number should be exactly 10 digits';
//     }
//     if (!/^[0-9]{6}$/.test(formData.postal_code)) {
//       newErrors.postal_code = 'Postal Code should be exactly 6 digits';
//     }
//     if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
//       newErrors.email = 'Invalid email address';
//     }
//     if (!formData.password) {
//       newErrors.password = 'Password is required';
//     } else if (formData.password.length < 8) {
//       newErrors.password = 'Password must be at least 8 characters';
//     }
//     if (formData.password !== formData.confirm_password) {
//       newErrors.confirm_password = 'Passwords do not match';
//     }
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));
//   };

  
 

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;
//     setLoading(true);
//     try {
//       const response = await fetch('https://newbackend.elephant-tank.com/api/register_stud/', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(formData),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         Swal.fire({
//           title: 'Success!',
//           text: 'Verify OTP for Confirmation of Registration.',
//           icon: 'success',
//           timer: 2000,
//           showConfirmButton: false,
//           willClose: () => navigate('/Otpverification', { state: { email: formData.email } }),
//         });
//       } else {
//         Swal.fire({
//           title: 'Error!',
//           text: data.msg || 'Registration failed!',
//           icon: 'error',
//           confirmButtonText: 'Try Again',
//         });
//       }
//     } catch (error) {
//       Swal.fire({
//         title: 'Error!',
//         text: 'An error occurred. Please try again.',
//         icon: 'error',
//         confirmButtonText: 'Close',
//       });
//     } finally {
//       setLoading(false);
//     }
//   };
  
  
//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         background: themeColors.background,
//         padding: '16px',
//       }}
//     >
//       <StyledPaper>
//         <LogoContainer>
//           <LogoImage src={Logo1} alt="Logo 1" />
//           <LogoImage src={Logo2} alt="Logo 2" />
//           <LogoImage src={Logo3} alt="Logo 3" />
//           <LogoImage src={Logo4} alt="Logo 4" />
//         </LogoContainer>
//         <Typography
//           variant="h5"
//           fontWeight="bold"
//           mb={3}
//           sx={{
//             color: 'transparent',
//             backgroundImage: themeColors.gradient,
//             backgroundClip: 'text',
//             WebkitBackgroundClip: 'text',
//             textAlign: 'center',
//             fontSize: '1.5rem',
//           }}
//         >
//           Empower Your Journey – Register Today to Become a Entrepreneur!
//         </Typography>

//         <form onSubmit={handleSubmit} style={{ width: '100%' }}>
//           <Grid container spacing={2}>
//             {Object.entries({
//               full_name: 'Full Name',
//               email: 'Email',
//               phone_number: 'Phone Number',
//               address: 'Address',
//               city: 'City',
//               state: 'State',
//               postal_code: 'Postal Code',
//               country: 'Country',
//               institution: 'College',
//               field_of_study: 'Field of Study',
//               graduation_year: 'Graduation Year',
//               linked_url: 'LinkedIn URL',
              
//             }).map(([name, label]) => (
//               <Grid item xs={12} sm={4} key={name}>
//                 <StyledTextField
//                   fullWidth
//                   label={label}
//                   name={name}
//                   type={name === 'graduation_year' || name === 'postal_code' ? 'number' : 'text'}
//                   value={formData[name]}
//                   onChange={handleChange}
//                   required
//                   error={!!errors[name]}
//                   helperText={errors[name]}
//                 />
//               </Grid>
//             ))}
//             <Grid item xs={12} sm={4}>
//               <StyledTextField
//                 fullWidth
//                 label="Password"
//                 name="password"
//                 type={showPassword ? 'text' : 'password'}
//                 value={formData.password}
//                 onChange={handleChange}
//                 required
//                 error={!!errors.password}
//                 helperText={errors.password}
//                 InputProps={{
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton onClick={() => setShowPassword(!showPassword)}>
//                         {showPassword ? <VisibilityOff /> : <Visibility />}
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//               />
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <StyledTextField
//                 fullWidth
//                 label="Confirm Password"
//                 name="confirm_password"
//                 type="password"
//                 value={formData.confirm_password}
//                 onChange={handleChange}
//                 required
//                 error={!!errors.confirm_password}
//                 helperText={errors.confirm_password}
//               />
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Gender</InputLabel>
//                 <Select
//                   name="gender"
//                   value={formData.gender}
//                   onChange={handleChange}
//                   required
//                 >
//                   <MenuItem value="M">Male</MenuItem>
//                   <MenuItem value="F">Female</MenuItem>
//                   <MenuItem value="O">Other</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//   <Grid item xs={12} sm={6} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Graduation Degree</InputLabel>
//                 <Select
//                   name="graduation_degree"
//                   value={formData.graduation_degree}
//                   onChange={handleChange}
//                   required
//                 >
//                   {['BBA', 'B. Com', 'B.Sc.', 'B. Tech/B.E.', 'B.Arch.', 'B.Pharm', 'BFA', 'Others','NA'].map((degree) => (
//                     <MenuItem key={degree} value={degree}>
//                       {degree}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12} sm={6} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Post-Graduation Degree</InputLabel>
//                 <Select
//                   name="post_graduation_degree"
//                   value={formData.post_graduation_degree}
//                   onChange={handleChange}
//                   required
//                 >
//                   {['MBA', 'MCA', 'PGDM', 'M.Pharm', 'B. Tech', 'M.Sc.', 'M. Arch', 'Others','NA'].map((degree) => (
//                     <MenuItem key={degree} value={degree}>
//                       {degree}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>


//             <Grid item xs={12}>
//               <RegisterButton type="submit" fullWidth disabled={loading}>
//                 {loading ? <CircularProgress size={24} /> : 'Register'}
//               </RegisterButton>
//             </Grid>
//           </Grid>
//         </form>
//       </StyledPaper>
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//       >
//         <Alert
//           onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//           severity={snackbar.severity}
//           sx={{ width: '100%' }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// }
// export function OtpVerification() {
//   const navigate = useNavigate();
//   const [otp, setOtp] = useState(new Array(4).fill(''));
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
//   const email = "Annabell4@yahoo.com"; // Example email, replace with actual data
//   const role = "Student"; // Role value, replace if needed

//   const handleChange = (element, index) => {
//     if (/^\d$/.test(element.value) || element.value === '') {
//       const newOtp = [...otp];
//       newOtp[index] = element.value;
//       setOtp(newOtp);

//       if (element.value && index < 3) {
//         document.getElementById(`otp-input-${index + 1}`).focus();
//       }
//     }
//   };
// }

// import React, { useState } from 'react';
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   IconButton,
//   InputAdornment,
//   Paper,
//   Snackbar,
//   Alert,
//   CircularProgress,
//   Grid,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
// } from '@mui/material';
// import { Visibility, VisibilityOff } from '@mui/icons-material';
// import { styled } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import Logo1 from '../../src/landpageimage/logo1.png';
// import Logo2 from '../../src/landpageimage/TDTLLogo.png';
// import Logo3 from '../../src/landpageimage/logo2.jpg';
// import Logo4 from '../landpageimage1/DYPLogo.png';
// import Swal from 'sweetalert2';

// const themeColors = {
//   primary: '#2196F3',
//   gradient: 'linear-gradient(135deg, #2196F3 0%, #6633EE 100%)',
//   background: 'radial-gradient(217.23% 100.08% at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, #6633EE 69.34%, rgb(15, 19, 26) 100%)',
// };

// const StyledPaper = styled(Paper)(() => ({
//   display: 'flex',
//   flexDirection: 'column',
//   alignItems: 'center',
//   width: '90%',
//   maxWidth: '1200px',
//   margin: '0 auto',
//   borderRadius: '24px',
//   padding: '16px',
//   backgroundColor: '#FFFFFF',
//   boxShadow: '0 20px 40px rgba(0, 167, 111, 0.15)',
// }));

// const LogoContainer = styled(Box)(() => ({
//   display: 'grid',
//   gridTemplateColumns: 'repeat(4, 1fr)',
//   gap: '16px',
//   justifyContent: 'center',
//   alignItems: 'center',
//   width: '100%',
//   padding: '16px 0',
//   marginBottom: '16px',
//   '@media (max-width: 600px)': {
//     gridTemplateColumns: 'repeat(2, 1fr)',
//   },
// }));

// const LogoImage = styled('img')(() => ({
//   maxWidth: '100px',
//   maxHeight: '80px',
//   objectFit: 'contain',
//   margin: '0 auto',
// }));

// const StyledTextField = styled(TextField)(() => ({
//   '& .MuiOutlinedInput-root': {
//     borderRadius: '12px',
//     backgroundColor: '#F3F4F6',
//     '&:hover': {
//       backgroundColor: '#F9FAFB',
//     },
//     '&.Mui-focused fieldset': {
//       borderColor: themeColors.primary,
//     },
//   },
// }));

// const RegisterButton = styled(Button)(() => ({
//   background: themeColors.gradient,
//   color: 'white',
//   padding: '8px',
//   borderRadius: '16px',
//   fontWeight: 600,
//   '&:hover': {
//     background: '#1E88E5',
//   },
// }));

// export default function StudentRegister() {
//   const navigate = useNavigate();
//   const [showPassword, setShowPassword] = useState(false);
//   const [formData, setFormData] = useState({
//     full_name: '',
//     email: '',
//     password: '',
//     confirm_password: '',
//     phone_number: '',
//     role: 'Student',
//     institution: '',
//     address: '',
//     postal_code: '',
//     country: '',
//     city: '',
//     state: '',
//     gender: '',
//     field_of_study: '',
//     graduation_year: '',
//     linked_url: '',
//   });
//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//   const validate = () => {
//     const newErrors = {};
//     if (!/^[a-zA-Z ]+$/.test(formData.full_name)) {
//       newErrors.full_name = 'Full Name should contain only letters and spaces';
//     }
//     if (!/^[0-9]{10}$/.test(formData.phone_number)) {
//       newErrors.phone_number = 'Phone Number should be exactly 10 digits';
//     }
//     if (!/^[0-9]{6}$/.test(formData.postal_code)) {
//       newErrors.postal_code = 'Postal Code should be exactly 6 digits';
//     }
//     if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
//       newErrors.email = 'Invalid email address';
//     }
//     if (!formData.password) {
//       newErrors.password = 'Password is required';
//     } else if (formData.password.length < 8) {
//       newErrors.password = 'Password must be at least 8 characters';
//     }
//     if (formData.password !== formData.confirm_password) {
//       newErrors.confirm_password = 'Passwords do not match';
//     }
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;
//     setLoading(true);
//     try {
//       const response = await fetch('https://newbackend.elephant-tank.com/api/register_stud/', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(formData),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         Swal.fire({
//           title: 'Success!',
//           text: 'Verify OTP for Confirmation of Registration.',
//           icon: 'success',
//           timer: 2000,
//           showConfirmButton: false,
//           willClose: () => navigate('/Otpverification', { state: { email: formData.email } }),
//         });
//       } else {
//         Swal.fire({
//           title: 'Error!',
//           text: data.msg || 'Registration failed!',
//           icon: 'error',
//           confirmButtonText: 'Try Again',
//         });
//       }
//     } catch (error) {
//       Swal.fire({
//         title: 'Error!',
//         text: 'An error occurred. Please try again.',
//         icon: 'error',
//         confirmButtonText: 'Close',
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const graduationYears = Array.from(
//     { length: 20 },
//     (_, i) => new Date().getFullYear() - i
//   ).reverse();

//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         background: themeColors.background,
//         padding: '16px',
//       }}
//     >
//       <StyledPaper>
//         <LogoContainer>
//           <LogoImage src={Logo1} alt="Logo 1" />
//           <LogoImage src={Logo2} alt="Logo 2" />
//           <LogoImage src={Logo3} alt="Logo 3" />
//           <LogoImage src={Logo4} alt="Logo 4" />
//         </LogoContainer>
//         <Typography
//           variant="h5"
//           fontWeight="bold"
//           mb={3}
//           sx={{
//             color: 'transparent',
//             backgroundImage: themeColors.gradient,
//             backgroundClip: 'text',
//             WebkitBackgroundClip: 'text',
//             textAlign: 'center',
//             fontSize: '1.5rem',
//           }}
//         >
//           Empower Your Journey – Register Today to Become an Entrepreneur!
//         </Typography>

//         <form onSubmit={handleSubmit} style={{ width: '100%' }}>
//           <Grid container spacing={2}>
//             {Object.entries({
//               full_name: 'Full Name',
//               email: 'Email',
//               phone_number: 'Phone Number',
//               address: 'Address',
//               city: 'City',
//               state: 'State',
//               postal_code: 'Postal Code',
//               country: 'Country',
//               institution: 'College',
//               field_of_study: 'Field of Study',
//               linked_url: 'LinkedIn URL',
//             }).map(([name, label]) => (
//               <Grid item xs={12} sm={4} key={name}>
//                 <StyledTextField
//                   fullWidth
//                   label={label}
//                   name={name}
//                   value={formData[name]}
//                   onChange={handleChange}
//                   required
//                   error={!!errors[name]}
//                   helperText={errors[name]}
//                 />
//               </Grid>
//             ))}
//             <Grid item xs={12} sm={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Graduation Year</InputLabel>
//                 <Select
//                   name="graduation_year"
//                   value={formData.graduation_year}
//                   onChange={handleChange}
//                   required
//                 >
//                   {graduationYears.map((year) => (
//                     <MenuItem key={year} value={year}>
//                       {year}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <StyledTextField
//                 fullWidth
//                 label="Password"
//                 name="password"
//                 type={showPassword ? 'text' : 'password'}
//                 value={formData.password}
//                 onChange={handleChange}
//                 required
//                 error={!!errors.password}
//                 helperText={errors.password}
//                 InputProps={{
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton onClick={() => setShowPassword(!showPassword)}>
//                         {showPassword ? <VisibilityOff /> : <Visibility />}
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//               />
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <StyledTextField
//                 fullWidth
//                 label="Confirm Password"
//                 name="confirm_password"
//                 type="password"
//                 value={formData.confirm_password}
//                 onChange={handleChange}
//                 required
//                 error={!!errors.confirm_password}
//                 helperText={errors.confirm_password}
//               />
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Gender</InputLabel>
//                 <Select
//                   name="gender"
//                   value={formData.gender}
//                   onChange={handleChange}
//                   required
//                 >
//                   <MenuItem value="M">Male</MenuItem>
//                   <MenuItem value="F">Female</MenuItem>
//                   <MenuItem value="O">Other</MenuItem>
//                 </Select>
//               </FormControl>

//             </Grid>
//             <Grid item xs={12} sm={6} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Graduation Degree</InputLabel>
//                 <Select
//                   name="graduation_degree"
//                   value={formData.graduation_degree}
//                   onChange={handleChange}
//                   required
//                 >
//                   {['BBA', 'B. Com', 'B.Sc.', 'B. Tech/B.E.', 'B.Arch.', 'B.Pharm', 'BFA', 'Others','NA'].map((degree) => (
//                     <MenuItem key={degree} value={degree}>
//                       {degree}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12} sm={6} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Post-Graduation Degree</InputLabel>
//                 <Select
//                   name="post_graduation_degree"
//                   value={formData.post_graduation_degree}
//                   onChange={handleChange}
//                   required
//                 >
//                   {['MBA', 'MCA', 'PGDM', 'M.Pharm', 'M. Tech', 'M.Sc.', 'M. Arch', 'Others','NA'].map((degree) => (
//                     <MenuItem key={degree} value={degree}>
//                       {degree}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12}>
//               <RegisterButton type="submit" fullWidth disabled={loading}>
//                 {loading ? <CircularProgress size={24} /> : 'Register'}
//               </RegisterButton>
//             </Grid>
//           </Grid>
//         </form>
//       </StyledPaper>
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//       >
//         <Alert
//           onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//           severity={snackbar.severity}
//           sx={{ width: '100%' }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// }

// import React, { useState } from 'react';
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   IconButton,
//   InputAdornment,
//   Paper,
//   Snackbar,
//   Alert,
//   CircularProgress,
//   Grid,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
// } from '@mui/material';
// import { Visibility, VisibilityOff } from '@mui/icons-material';
// import { styled } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import Swal from 'sweetalert2';
// import Logo1 from '../../src/landpageimage/logo1.png';
// import Logo2 from '../../src/landpageimage/TDTLLogo.png';
// import Logo3 from '../../src/landpageimage/logo2.jpg';
// import Logo4 from '../landpageimage1/DYPLogo.png';

// const themeColors = {
//   primary: '#2196F3',
//   gradient: 'linear-gradient(135deg, #2196F3 0%, #6633EE 100%)',
//   background: 'radial-gradient(217.23% 100.08% at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, #6633EE 69.34%, rgb(15, 19, 26) 100%)',
// };

// const StyledPaper = styled(Paper)(() => ({
//   display: 'flex',
//   flexDirection: 'column',
//   alignItems: 'center',
//   width: '90%',
//   maxWidth: '1200px',
//   margin: '0 auto',
//   borderRadius: '24px',
//   padding: '16px',
//   backgroundColor: '#FFFFFF',
//   boxShadow: '0 20px 40px rgba(0, 167, 111, 0.15)',
// }));

// const StyledTextField = styled(TextField)(() => ({
//   '& .MuiOutlinedInput-root': {
//     borderRadius: '12px',
//     backgroundColor: '#F3F4F6',
//     '&:hover': {
//       backgroundColor: '#F9FAFB',
//     },
//     '&.Mui-focused fieldset': {
//       borderColor: themeColors.primary,
//     },
//   },
// }));

// const RegisterButton = styled(Button)(() => ({
//   background: themeColors.gradient,
//   color: 'white',
//   padding: '8px',
//   borderRadius: '16px',
//   fontWeight: 600,
//   '&:hover': {
//     background: '#1E88E5',
//   },
// }));

// const LogoContainer = styled(Box)(() => ({
//   display: 'grid',
//   gridTemplateColumns: 'repeat(4, 1fr)',
//   gap: '16px',
//   justifyContent: 'center',
//   alignItems: 'center',
//   width: '100%',
//   padding: '16px 0',
//   marginBottom: '16px',
//   '@media (max-width: 600px)': {
//     gridTemplateColumns: 'repeat(2, 1fr)',
//   },
// }));

// const LogoImage = styled('img')(() => ({
//   maxWidth: '100px',
//   maxHeight: '80px',
//   objectFit: 'contain',
//   margin: '0 auto',
// }));

// export default function StudentRegister() {
//   const navigate = useNavigate();
//   const [showPassword, setShowPassword] = useState(false);
//   const [formData, setFormData] = useState({
//     full_name: '',
//     role: 'Student',
//     email: '',
//     phone_number: '',
//     address: '',
//     city: '',
//     state: '',
//     postal_code: '',
//     country: '',
//     institution: '',
//     field_of_study: '',
//     linked_url: '',
//     graduation_year: '',
//     graduation_degree: '',
//     post_graduation_degree: '',
//     gender: '',
//     password: '',
//     confirm_password: '',
//   });
//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//   const validate = () => {
//     const newErrors = {};

//     if (!/^[a-zA-Z ]+$/.test(formData.full_name)) {
//       newErrors.full_name = 'Full Name should contain only letters and spaces';
//     }

//     if (!/^[0-9]{10}$/.test(formData.phone_number)) {
//       newErrors.phone_number = 'Phone Number should be exactly 10 digits';
//     }

//     if (!/^[0-9]{6}$/.test(formData.postal_code)) {
//       newErrors.postal_code = 'Postal Code should be exactly 6 digits';
//     }

//     if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
//       newErrors.email = 'Invalid email address';
//     }

//     if (!/^.{1,100}$/.test(formData.address)) {
//       newErrors.address = 'Address should not exceed 100 characters';
//     }

//     if (!/^[a-zA-Z ]{2,50}$/.test(formData.city)) {
//       newErrors.city = 'City should contain only letters and spaces';
//     }

//     if (!/^[a-zA-Z ]{2,50}$/.test(formData.state)) {
//       newErrors.state = 'State should contain only letters and spaces';
//     }

//     if (!/^[a-zA-Z ]{2,50}$/.test(formData.country)) {
//       newErrors.country = 'Country should contain only letters and spaces';
//     }
//     if (!/^[a-zA-Z ]{2,50}$/.test(formData.field_of_study)) {
//       newErrors.field_of_study = 'Field of Study should contain only letters and spaces';
//     }

//     if (!/^(https?:\/\/)?(www\.)?linkedin\.com\/.*$/.test(formData.linked_url)) {
//       newErrors.linked_url = 'Invalid LinkedIn URL';
//     }

//     if (!formData.password) {
//       newErrors.password = 'Password is required';
//     } else if (formData.password.length < 8) {
//       newErrors.password = 'Password must be at least 8 characters';
//     }

//     if (formData.password !== formData.confirm_password) {
//       newErrors.confirm_password = 'Passwords do not match';
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;
//     setLoading(true);
//     try {
//       const response = await fetch('https://newbackend.elephant-tank.com/api/register_stud/', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(formData),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         Swal.fire({
//           title: 'Success!',
//           text: 'Verify OTP for Confirmation of Registration.',
//           icon: 'success',
//           timer: 2000,
//           showConfirmButton: false,
//           willClose: () => navigate('/Otpverification', { state: { email: formData.email } }),
//         });
//       } else {
//         Swal.fire({
//           title: 'Error!',
//           text: data.msg || 'Registration failed!',
//           icon: 'error',
//           confirmButtonText: 'Try Again',
//         });
//       }
//     } catch (error) {
//       Swal.fire({
//         title: 'Error!',
//         text: 'An error occurred. Please try again.',
//         icon: 'error',
//         confirmButtonText: 'Close',
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   // const graduationYears = Array.from(
//   //   { length: 20 },
//   //   (_, i) => new Date().getFullYear() - i
//   // ).reverse();
//   const graduationYears = Array.from({ length: 2027 - 2005 + 1 }, (_, i) => 2005 + i).reverse();

//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         background: themeColors.background,
//         padding: '16px',
//       }}
//     >
//       <StyledPaper>
//       <LogoContainer>
//           <LogoImage src={Logo1} alt="Logo 1" />
//           <LogoImage src={Logo2} alt="Logo 2" />
//           <LogoImage src={Logo3} alt="Logo 3" />
//           <LogoImage src={Logo4} alt="Logo 4" />
//         </LogoContainer>
//         <Typography
//           variant="h5"
//           fontWeight="bold"
//           mb={3}
//           sx={{
//             color: 'transparent',
//             backgroundImage: themeColors.gradient,
//             backgroundClip: 'text',
//             WebkitBackgroundClip: 'text',
//             textAlign: 'center',
//             fontSize: '1.5rem',
//           }}
//         >
//           Empower Your Journey – Register Today to Become an Entrepreneur!
//         </Typography>

//         <form onSubmit={handleSubmit} style={{ width: '100%' }}>
//           <Grid container spacing={2}>
//             {Object.entries({
//               full_name: 'Full Name',
//               email: 'Email',
//               phone_number: 'Phone Number',
//               address: 'Address',
//               city: 'City',
//               state: 'State',
//               postal_code: 'Postal Code',
//               country: 'Country',
//               institution: 'College',
//               field_of_study: 'Field of Study',
//               linked_url: 'LinkedIn URL',
//             }).map(([name, label]) => (
//               <Grid item xs={12} sm={4} key={name}>
//                 <StyledTextField
//                   fullWidth
//                   label={label}
//                   name={name}
//                   value={formData[name]}
//                   onChange={handleChange}
//                   required
//                   error={!!errors[name]}
//                   helperText={errors[name]}
//                 />
//               </Grid>
//             ))}
//             <Grid item xs={12} sm={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Graduation Year</InputLabel>
//                 <Select
//                   name="graduation_year"
//                   value={formData.graduation_year}
//                   onChange={handleChange}
//                   required
//                 >
//                   {graduationYears.map((year) => (
//                     <MenuItem key={year} value={year}>
//                       {year}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <StyledTextField
//                 fullWidth
//                 label="Password"
//                 name="password"
//                 type={showPassword ? 'text' : 'password'}
//                 value={formData.password}
//                 onChange={handleChange}
//                 required
//                 error={!!errors.password}
//                 helperText={errors.password}
//                 InputProps={{
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton onClick={() => setShowPassword(!showPassword)}>
//                         {showPassword ? <VisibilityOff /> : <Visibility />}
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//               />
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <StyledTextField
//                 fullWidth
//                 label="Confirm Password"
//                 name="confirm_password"
//                 type="password"
//                 value={formData.confirm_password}
//                 onChange={handleChange}
//                 required
//                 error={!!errors.confirm_password}
//                 helperText={errors.confirm_password}
//               />
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Gender</InputLabel>
//                 <Select
//                   name="gender"
//                   value={formData.gender}
//                   onChange={handleChange}
//                   required
//                 >
//                   <MenuItem value="M">Male</MenuItem>
//                   <MenuItem value="F">Female</MenuItem>
//                   <MenuItem value="O">Other</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} sm={6} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Graduation Degree</InputLabel>
//                 <Select
//                   name="graduation_degree"
//                   value={formData.graduation_degree}
//                   onChange={handleChange}
//                   required
//                 >
//                   {['BBA', 'B. Com', 'B.Sc.', 'B. Tech/B.E.', 'B.Arch.', 'B.Pharm', 'BFA', 'Others', 'NA'].map((degree) => (
//                     <MenuItem key={degree} value={degree}>
//                       {degree}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} sm={6} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Post-Graduation Degree</InputLabel>
//                 <Select
//                   name="post_graduation_degree"
//                   value={formData.post_graduation_degree}
//                   onChange={handleChange}
//                   required
//                 >
//                   {['MBA', 'MCA', 'PGDM', 'M.Pharm', 'M. Tech', 'M.Sc.', 'M. Arch', 'Others', 'NA'].map((degree) => (
//                     <MenuItem key={degree} value={degree}>
//                       {degree}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12}>
//               <RegisterButton type="submit" fullWidth disabled={loading}>
//                 {loading ? <CircularProgress size={24} /> : 'Register'}
//               </RegisterButton>
//             </Grid>
//           </Grid>
//         </form>
//       </StyledPaper>
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//       >
//         <Alert
//           onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//           severity={snackbar.severity}
//           sx={{ width: '100%' }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// }

// import React, { useState } from 'react';
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   IconButton,
//   InputAdornment,
//   Paper,
//   CircularProgress,
//   Grid,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
// } from '@mui/material';
// import { Visibility, VisibilityOff } from '@mui/icons-material';
// import { styled } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import Swal from 'sweetalert2';
// import Logo1 from '../../src/landpageimage/logo1.png';
// import Logo2 from '../../src/landpageimage/TDTLLogo.png';
// import Logo3 from '../../src/landpageimage/logo2.jpg';
// import Logo4 from '../landpageimage1/DYPLogo.png';

// const themeColors = {
//   primary: '#2196F3',
//   gradient: 'linear-gradient(135deg, #2196F3 0%, #6633EE 100%)',
//   background: 'radial-gradient(217.23% 100.08% at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, #6633EE 69.34%, rgb(15, 19, 26) 100%)',
// };

// const StyledPaper = styled(Paper)(() => ({
//   display: 'flex',
//   flexDirection: 'column',
//   alignItems: 'center',
//   width: '90%',
//   maxWidth: '1200px',
//   margin: '0 auto',
//   borderRadius: '24px',
//   padding: '16px',
//   backgroundColor: '#FFFFFF',
//   boxShadow: '0 20px 40px rgba(0, 167, 111, 0.15)',
// }));

// const StyledTextField = styled(TextField)(() => ({
//   '& .MuiOutlinedInput-root': {
//     borderRadius: '12px',
//     backgroundColor: '#F3F4F6',
//     '&:hover': {
//       backgroundColor: '#F9FAFB',
//     },
//     '&.Mui-focused fieldset': {
//       borderColor: themeColors.primary,
//     },
//   },
// }));

// const RegisterButton = styled(Button)(() => ({
//   background: themeColors.gradient,
//   color: 'white',
//   padding: '8px',
//   borderRadius: '16px',
//   fontWeight: 600,
//   '&:hover': {
//     background: '#1E88E5',
//   },
// }));

// const LogoContainer = styled(Box)(() => ({
//   display: 'grid',
//   gridTemplateColumns: 'repeat(4, 1fr)',
//   gap: '16px',
//   justifyContent: 'center',
//   alignItems: 'center',
//   width: '100%',
//   padding: '16px 0',
//   marginBottom: '16px',
//   '@media (max-width: 600px)': {
//     gridTemplateColumns: 'repeat(2, 1fr)',
//   },
// }));

// const LogoImage = styled('img')(() => ({
//   maxWidth: '100px',
//   maxHeight: '80px',
//   objectFit: 'contain',
//   margin: '0 auto',
// }));

// export default function StudentRegister() {
//   const navigate = useNavigate();
//   const [showPassword, setShowPassword] = useState(false);
//   const [formData, setFormData] = useState({
//     full_name: "",
//     email: "",
//     password: "",
//     phone_number: "",
//     role: "Student",
//     institution: "",
//     address: "",
//     postal_code: "",
//     country: "",
//     city: "",
//     state: "",
//     gender: "",
//     field_of_study: "",
//     graduation_year: 2025,
//     linked_url: "",
//     post_graduation_degree: "",
//     graduation_degree: "",
//     is_group: "",
//     group_name: "",
//     group_members: "",
//     email2: "",
//     email3: "",
//     email4: ""
//   });
//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);

//   const validate = () => {
//     const newErrors = {};

//     if (!/^[a-zA-Z ]+$/.test(formData.full_name)) {
//       newErrors.full_name = 'Full Name should contain only letters and spaces';
//     }
//     if (!/^[0-9]{10}$/.test(formData.phone_number)) {
//       newErrors.phone_number = 'Phone Number should be exactly 10 digits';
//     }
//     if (!/^[0-9]{6}$/.test(formData.postal_code)) {
//       newErrors.postal_code = 'Postal Code should be exactly 6 digits';
//     }
//     if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
//       newErrors.email = 'Invalid email address';
//     }
//     if (!/^.{1,100}$/.test(formData.address)) {
//       newErrors.address = 'Address should not exceed 100 characters';
//     }
//     if (!/^[a-zA-Z ]{2,50}$/.test(formData.city)) {
//       newErrors.city = 'City should contain only letters and spaces';
//     }
//     if (!/^[a-zA-Z ]{2,50}$/.test(formData.state)) {
//       newErrors.state = 'State should contain only letters and spaces';
//     }
//     if (!/^[a-zA-Z ]{2,50}$/.test(formData.country)) {
//       newErrors.country = 'Country should contain only letters and spaces';
//     }
//     if (!/^[a-zA-Z ]{2,50}$/.test(formData.field_of_study)) {
//       newErrors.field_of_study = 'Field of Study should contain only letters and spaces';
//     }
//     if (!/^(https?:\/\/)?(www\.)?linkedin\.com\/.*$/.test(formData.linked_url)) {
//       newErrors.linked_url = 'Invalid LinkedIn URL';
//     }
//     if (!formData.password) {
//       newErrors.password = 'Password is required';
//     } else if (formData.password.length < 8) {
//       newErrors.password = 'Password must be at least 8 characters';
//     }

//     if (formData.is_group === 'True') {
//       const groupSize = parseInt(formData.group_members, 10);
//       if (groupSize < 1 || groupSize > 4) {
//         newErrors.group_members = 'Group size must be between 1 and 4';
//       }
//       ['email2', 'email3', 'email4'].forEach((email, index) => {
//         if (formData[email] && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData[email])) {
//           newErrors[email] = `Invalid email for Team Member ${index + 2}`;
//         }
//       });
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;
//     setLoading(true);
//     try {
//       const response = await fetch('https://newbackend.elephant-tank.com/api/register_stud/', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(formData),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         Swal.fire({
//           title: 'Success!',
//           text: 'Verify OTP for Confirmation of Registration.',
//           icon: 'success',
//           timer: 2000,
//           showConfirmButton: false,
//           willClose: () => navigate('/Otpverification', { state: { email: formData.email } }),
//         });
//       } else {
//         Swal.fire({
//           title: 'Error!',
//           text: data.msg || 'Registration failed!',
//           icon: 'error',
//           confirmButtonText: 'Try Again',
//         });
//       }
//     } catch (error) {
//       Swal.fire({
//         title: 'Error!',
//         text: 'An error occurred. Please try again.',
//         icon: 'error',
//         confirmButtonText: 'Close',
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const graduationYears = Array.from({ length: 2027 - 2005 + 1 }, (_, i) => 2005 + i).reverse();

//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         background: themeColors.background,
//         padding: '16px',
//       }}
//     >
//       <StyledPaper>
//         <LogoContainer>
//           <LogoImage src={Logo1} alt="Logo 1" />
//           <LogoImage src={Logo2} alt="Logo 2" />
//           <LogoImage src={Logo3} alt="Logo 3" />
//           <LogoImage src={Logo4} alt="Logo 4" />
//         </LogoContainer>
//         <Typography
//           variant="h5"
//           fontWeight="bold"
//           mb={3}
//           sx={{
//             color: 'transparent',
//             backgroundImage: themeColors.gradient,
//             backgroundClip: 'text',
//             WebkitBackgroundClip: 'text',
//             textAlign: 'center',
//             fontSize: '1.5rem',
//           }}
//         >
//           Empower Your Journey – Register Today to Become an Entrepreneur!
//         </Typography>
//         <form onSubmit={handleSubmit} style={{ width: '100%' }}>
//           <Grid container spacing={2}>
//             {['full_name', 'email', 'phone_number', 'address', 'city', 'state', 'postal_code', 'country', 'institution', 'field_of_study', 'linked_url'].map((field) => (
//               <Grid item xs={12} sm={4} key={field}>
//                 <StyledTextField
//                   fullWidth
//                   label={field.replace(/_/g, ' ')}
//                   name={field}
//                   value={formData[field]}
//                   onChange={handleChange}
//                   required
//                   error={!!errors[field]}
//                   helperText={errors[field]}
//                 />
//               </Grid>
//             ))}

//             <Grid item xs={12} sm={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Graduation Year</InputLabel>
//                 <Select
//                   name="graduation_year"
//                   value={formData.graduation_year}
//                   onChange={handleChange}
//                   required
//                 >
//                   {graduationYears.map((year) => (
//                     <MenuItem key={year} value={year}>
//                       {year}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12} sm={4}>
//               <StyledTextField
//                 fullWidth
//                 label="Password"
//                 name="password"
//                 type={showPassword ? 'text' : 'password'}
//                 value={formData.password}
//                 onChange={handleChange}
//                 required
//                 error={!!errors.password}
//                 helperText={errors.password}
//                 InputProps={{
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton onClick={() => setShowPassword(!showPassword)}>
//                         {showPassword ? <VisibilityOff /> : <Visibility />}
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//               />
//             </Grid>

//             <Grid item xs={12} sm={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Gender</InputLabel>
//                 <Select
//                   name="gender"
//                   value={formData.gender}
//                   onChange={handleChange}
//                   required
//                 >
//                   <MenuItem value="M">Male</MenuItem>
//                   <MenuItem value="F">Female</MenuItem>
//                   <MenuItem value="O">Other</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12} sm={6} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Graduation Degree</InputLabel>
//                 <Select
//                   name="graduation_degree"
//                   value={formData.graduation_degree}
//                   onChange={handleChange}
//                   required
//                 >
//                   {['BBA', 'B. Com', 'B.Sc.', 'B. Tech/B.E.', 'B.Arch.', 'B.Pharm', 'BFA', 'Others', 'NA'].map((degree) => (
//                     <MenuItem key={degree} value={degree}>
//                       {degree}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12} sm={6} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Post-Graduation Degree</InputLabel>
//                 <Select
//                   name="post_graduation_degree"
//                   value={formData.post_graduation_degree}
//                   onChange={handleChange}
//                   required
//                 >
//                   {['MBA', 'MCA', 'PGDM', 'M.Pharm', 'M. Tech/M.E', 'M.Sc.', 'M. Arch', 'Others', 'NA'].map((degree) => (
//                     <MenuItem key={degree} value={degree}>
//                       {degree}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12} sm={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Participation Type</InputLabel>
//                 <Select
//                   name="is_group"
//                   value={formData.is_group}
//                   onChange={handleChange}
//                 >
//                   <MenuItem value="False">Single Participation</MenuItem>
//                   <MenuItem value="True">Group Participation</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             {formData.is_group === 'True' && (
//               <>
//                 <Grid item xs={12} sm={4}>
//                   <StyledTextField
//                     fullWidth
//                     label="Group Name"
//                     name="group_name"
//                     value={formData.group_name}
//                     onChange={handleChange}
//                     error={!!errors.group_name}
//                     helperText={errors.group_name}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={4}>
//                   <StyledTextField
//                     fullWidth
//                     label="Number of Members (1-4)"
//                     name="group_members"
//                     value={formData.group_members}
//                     onChange={handleChange}
//                     error={!!errors.group_members}
//                     helperText={errors.group_members}
//                   />
//                 </Grid>
//                 {['email2', 'email3', 'email4'].map((email, index) => (
//                   <Grid item xs={12} sm={6} key={email}>
//                     <StyledTextField
//                       fullWidth
//                       label={`Team Member ${index + 2} Email`}
//                       name={email}
//                       value={formData[email]}
//                       onChange={handleChange}
//                       error={!!errors[email]}
//                       helperText={errors[email]}
//                     />
//                   </Grid>
//                 ))}
//               </>
//             )}
//           </Grid>
//           <Box mt={3} display="flex" justifyContent="center">
//             <RegisterButton type="submit" disabled={loading}>
//               {loading ? <CircularProgress size={24} /> : 'Register'}
//             </RegisterButton>
//           </Box>
//         </form>
//       </StyledPaper>
//     </Box>
//   );
// }

import React, { useState } from 'react';
import {
  Box,
  Button,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
  Paper,
  CircularProgress,
  Grid,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import Logo1 from '../../src/landpageimage/logo1.png';
import Logo2 from '../../src/landpageimage/TDTLLogo.png';
import Logo3 from '../../src/landpageimage/logo2.jpg';
import Logo4 from '../landpageimage1/DYPLogo.png';

const themeColors = {
  primary: '#2196F3',
  gradient: 'linear-gradient(135deg, #2196F3 0%, #6633EE 100%)',
  background: 'radial-gradient(217.23% 100.08% at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, #6633EE 69.34%, rgb(15, 19, 26) 100%)',
};

const StyledPaper = styled(Paper)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '90%',
  maxWidth: '1200px',
  margin: '0 auto',
  borderRadius: '24px',
  padding: '16px',
  backgroundColor: '#FFFFFF',
  boxShadow: '0 20px 40px rgba(0, 167, 111, 0.15)',
}));

const StyledTextField = styled(TextField)(() => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: '12px',
    backgroundColor: '#F3F4F6',
    '&:hover': {
      backgroundColor: '#F9FAFB',
    },
    '&.Mui-focused fieldset': {
      borderColor: themeColors.primary,
    },
  },
}));

const RegisterButton = styled(Button)(() => ({
  background: themeColors.gradient,
  color: 'white',
  padding: '8px',
  borderRadius: '16px',
  fontWeight: 600,
  '&:hover': {
    background: '#1E88E5',
  },
}));

const LogoContainer = styled(Box)(() => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  gap: '16px',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  padding: '16px 0',
  marginBottom: '16px',
  '@media (max-width: 600px)': {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
}));

const LogoImage = styled('img')(() => ({
  maxWidth: '100px',
  maxHeight: '80px',
  objectFit: 'contain',
  margin: '0 auto',
}));

export default function StudentRegister() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    password: "",
    phone_number: "",
    role: "Student",
    institution: "",
    address: "",
    postal_code: "",
    country: "",
    city: "",
    state: "",
    gender: "",
    field_of_study: "",
    graduation_year: 2025,
    linked_url: "",
    post_graduation_degree: "",
    graduation_degree: "",
    is_group: "",
    group_name: "",
    group_members: "",
    email2: "",
    email3: "",
    email4: "",
    confirm_password: '',
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validate = () => {
    const newErrors = {};

    if (!/^[a-zA-Z ]+$/.test(formData.full_name)) {
      newErrors.full_name = 'Full Name should contain only letters and spaces';
    }
    if (!/^[0-9]{10}$/.test(formData.phone_number)) {
      newErrors.phone_number = 'Phone Number should be exactly 10 digits';
    }
    if (!/^[0-9]{6}$/.test(formData.postal_code)) {
      newErrors.postal_code = 'Postal Code should be exactly 6 digits';
    }
    if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Invalid email address';
    }
    if (!/^.{1,100}$/.test(formData.address)) {
      newErrors.address = 'Address should not exceed 100 characters';
    }
    if (!/^[a-zA-Z ]{2,50}$/.test(formData.city)) {
      newErrors.city = 'City should contain only letters and spaces';
    }
    if (!/^[a-zA-Z ]{2,50}$/.test(formData.state)) {
      newErrors.state = 'State should contain only letters and spaces';
    }
        if (formData.password !== formData.confirm_password) {
      newErrors.confirm_password = 'Passwords do not match';
    }
    if (!/^[a-zA-Z ]{2,50}$/.test(formData.country)) {
      newErrors.country = 'Country should contain only letters and spaces';
    }
        if (formData.password !== formData.confirm_password) {
      newErrors.confirm_password = 'Passwords do not match';
    }
    if (!/^[a-zA-Z ]{2,50}$/.test(formData.field_of_study)) {
      newErrors.field_of_study = 'Field of Study should contain only letters and spaces';
    }
    if (!/^(https?:\/\/)?(www\.)?linkedin\.com\/.*$/.test(formData.linked_url)) {
      newErrors.linked_url = 'Invalid LinkedIn URL';
    }
    if (!formData.password) {
      newErrors.password = 'Password is required';
    } else if (formData.password.length < 8) {
      newErrors.password = 'Password must be at least 8 characters';
    }

    if (formData.is_group === 'True') {
      const groupSize = parseInt(formData.group_members, 10);
      if (groupSize < 1 || groupSize > 4) {
        newErrors.group_members = 'Group size must be between 1 and 4';
      }
      ['email2', 'email3', 'email4'].forEach((email, index) => {
        if (formData[email] && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData[email])) {
          newErrors[email] = `Invalid email for Team Member ${index + 2}`;
        }
      });
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (!validate()) return;
  //   setLoading(true);
  //   try {
  //     const response = await fetch('https://newbackend.elephant-tank.com/api/register_stud/', {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify(formData),
  //     });
  //     const data = await response.json();
  //     if (response.ok) {
  //       Swal.fire({
  //         title: 'Success!',
  //         text: 'Verify OTP for Confirmation of Registration.',
  //         icon: 'success',
  //         timer: 2000,
  //         showConfirmButton: false,
  //         willClose: () => navigate('/Otpverification', { state: { email: formData.email } }),
  //       });
  //     } else {
  //       Swal.fire({
  //         title: 'Error!',
  //         text: data.msg || 'Registration failed!',
  //         icon: 'error',
  //         confirmButtonText: 'Try Again',
  //       });
  //     }
  //   } catch (error) {
  //     Swal.fire({
  //       title: 'Error!',
  //       text: 'An error occurred. Please try again.',
  //       icon: 'error',
  //       confirmButtonText: 'Close',
  //     });
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  
  //   if (!validate()) return;
  
  //   // Conditionally set email fields to "0" if the user selects "Single"
  //   const updatedFormData = {
  //     ...formData,
  //     email2: formData.is_group === 'Single' ? "0" : formData.email2,
  //     email3: formData.is_group === 'Single' ? "0" : formData.email3,
  //     email4: formData.is_group === 'Single' ? "0" : formData.email4,
  //   };
  
  //   setLoading(true);
  //   try {
  //     const response = await fetch('https://newbackend.elephant-tank.com/api/register_stud/', {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify(updatedFormData),
  //     });
  //     const data = await response.json();
  //     if (response.ok) {
  //       Swal.fire({
  //         title: 'Success!',
  //         text: 'Verify OTP for Confirmation of Registration.',
  //         icon: 'success',
  //         timer: 2000,
  //         showConfirmButton: false,
  //         willClose: () => navigate('/Otpverification', { state: { email: formData.email } }),
  //       });
  //     } else {
  //       Swal.fire({
  //         title: 'Error!',
  //         text: data.msg || 'Registration failed!',
  //         icon: 'error',
  //         confirmButtonText: 'Try Again',
  //       });
  //     }
  //   } catch (error) {
  //     Swal.fire({
  //       title: 'Error!',
  //       text: 'An error occurred. Please try again.',
  //       icon: 'error',
  //       confirmButtonText: 'Close',
  //     });
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!validate()) return;
  
    // Adjust payload for single participation
    const updatedPayload = {
      ...formData,
      email2: formData.is_group === "False" ? "0" : formData.email2,
      email3: formData.is_group === "False" ? "0" : formData.email3,
      email4: formData.is_group === "False" ? "0" : formData.email4,
      group_members: formData.is_group === "False" ? "0" : formData.group_members,
      group_name: formData.is_group === "False" ? "0" : formData.group_name,
    };
  
    setLoading(true);
    try {
      const response = await fetch('https://newbackend.elephant-tank.com/api/register_stud/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updatedPayload),
      });
      const data = await response.json();
      if (response.ok) {
        Swal.fire({
          title: 'Success!',
          text: 'Verify OTP for Confirmation of Registration.',
          icon: 'success',
          timer: 2000,
          showConfirmButton: false,
          willClose: () => navigate('/Otpverification', { state: { email: formData.email } }),
        });
      } else {
        Swal.fire({
          title: 'Error!',
          text: data.msg || 'Registration failed!',
          icon: 'error',
          confirmButtonText: 'Try Again',
        });
      }
    } catch (error) {
      Swal.fire({
        title: 'Error!',
        text: 'An error occurred. Please try again.',
        icon: 'error',
        confirmButtonText: 'Close',
      });
    } finally {
      setLoading(false);
    }
  };
  
  
  const graduationYears = Array.from({ length: 2027 - 2005 + 1 }, (_, i) => 2005 + i).reverse();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: themeColors.background,
        padding: '16px',
      }}
    >
      <StyledPaper>
        <LogoContainer>
          <LogoImage src={Logo1} alt="Logo 1" />
          <LogoImage src={Logo2} alt="Logo 2" />
          <LogoImage src={Logo3} alt="Logo 3" />
          <LogoImage src={Logo4} alt="Logo 4" />
        </LogoContainer>
        <Typography
          variant="h5"
          fontWeight="bold"
          mb={3}
          sx={{
            color: 'transparent',
            backgroundImage: themeColors.gradient,
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            textAlign: 'center',
            fontSize: '1.5rem',
          }}
        >
          Empower Your Journey – Register Today to Become an Entrepreneur!
        </Typography>
        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
          <Grid container spacing={2}>
            {['full_name', 'email', 'phone_number', 'address', 'city', 'state', 'postal_code', 'country', 'institution', 'field_of_study', 'linked_url'].map((field) => (
              <Grid item xs={12} sm={4} key={field}>
                <StyledTextField
                  fullWidth
                  label={field.replace(/_/g, ' ')}
                  name={field}
                  value={formData[field]}
                  onChange={handleChange}
                  required
                  error={!!errors[field]}
                  helperText={errors[field]}
                />
              </Grid>
            ))}

            <Grid item xs={12} sm={4}>
              <FormControl fullWidth>
                <InputLabel>Graduation Year</InputLabel>
                <Select
                  name="graduation_year"
                  value={formData.graduation_year}
                  onChange={handleChange}
                  required
                >
                  {graduationYears.map((year) => (
                    <MenuItem key={year} value={year}>
                      {year}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={4}>
              <StyledTextField
                fullWidth
                label="Password"
                name="password"
                type={showPassword ? 'text' : 'password'}
                value={formData.password}
                onChange={handleChange}
                required
                error={!!errors.password}
                helperText={errors.password}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => setShowPassword(!showPassword)}>
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            
             <Grid item xs={12} sm={4}>
              <StyledTextField
                fullWidth
                label="Confirm Password"
                name="confirm_password"
                type="password"
                value={formData.confirm_password}
                onChange={handleChange}
                required
                error={!!errors.confirm_password}
                helperText={errors.confirm_password}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <FormControl fullWidth>
                <InputLabel>Gender</InputLabel>
                <Select
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                  required
                >
                  <MenuItem value="M">Male</MenuItem>
                  <MenuItem value="F">Female</MenuItem>
                  <MenuItem value="O">Other</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth>
                <InputLabel>Graduation Degree</InputLabel>
                <Select
                  name="graduation_degree"
                  value={formData.graduation_degree}
                  onChange={handleChange}
                  required
                >
                  {['BBA', 'B. Com', 'B.Sc.', 'B. Tech/B.E.', 'B.Arch.', 'B.Pharm', 'BFA', 'Others', 'NA'].map((degree) => (
                    <MenuItem key={degree} value={degree}>
                      {degree}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth>
                <InputLabel>Post-Graduation Degree</InputLabel>
                <Select
                  name="post_graduation_degree"
                  value={formData.post_graduation_degree}
                  onChange={handleChange}
                  required
                >
                  {['MBA', 'MCA', 'PGDM', 'M.Pharm', 'M. Tech/M.E', 'M.Sc.', 'M. Arch', 'Others', 'NA'].map((degree) => (
                    <MenuItem key={degree} value={degree}>
                      {degree}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={4}>
              <FormControl fullWidth>
                <InputLabel>Participation Type</InputLabel>
                <Select
                  name="is_group"
                  value={formData.is_group}
                  onChange={handleChange}
                  required
                >
                  <MenuItem value="False">Single Participation</MenuItem>
                  <MenuItem value="True">Group Participation</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {formData.is_group === 'True' && (
              <>
                <Grid item xs={12} sm={4}>
                  <StyledTextField
                    fullWidth
                    label="Group Name"
                    name="group_name"
                    value={formData.group_name}
                    onChange={handleChange}
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <StyledTextField
                    fullWidth
                    label="Group Members (limit 1-4 max)"
                    name="group_members"
                    value={formData.group_members}
                    onChange={handleChange}
                    type="number"
                    inputProps={{ min: 1 }}
                  />
                </Grid>

                {formData.group_members >= 2 && (
                  <Grid item xs={12} sm={4}>
                    <StyledTextField
                      fullWidth
                      label="Email of Team Member 2"
                      name="email2"
                      value={formData.email2}
                      onChange={handleChange}
                      error={!!errors.email2}
                      helperText={errors.email2}
                    />
                  </Grid>
                )}
                {formData.group_members >= 3 && (
                  <Grid item xs={12} sm={4}>
                    <StyledTextField
                      fullWidth
                      label="Email of Team Member 3"
                      name="email3"
                      value={formData.email3}
                      onChange={handleChange}
                      error={!!errors.email3}
                      helperText={errors.email3}
                    />
                  </Grid>
                )}
                {formData.group_members >= 4 && (
                  <Grid item xs={12} sm={4}>
                    <StyledTextField
                      fullWidth
                      label="Email of Team Member 4"
                      name="email4"
                      value={formData.email4}
                      onChange={handleChange}
                      error={!!errors.email4}
                      helperText={errors.email4}
                    />
                  </Grid>
                )}
              </>
            )}

            <Grid item xs={12}>
              <RegisterButton
                fullWidth
                type="submit"
                variant="contained"
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} /> : 'Register'}
              </RegisterButton>
            </Grid>
          </Grid>
        </form>
      </StyledPaper>
    </Box>
  );
}